import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  state as animationState,
  style,
  transition,
  trigger
} from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  makeStateKey,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  TransferState,
  ViewChild
} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserDataService, UserSessionService } from '@com-delta-idp/mnx-oauth';
import {
  HEADER_MENU,
  HEADER_MENU_BOOK,
  HEADER_TOP_MENU,
  Irop,
  IropService,
  logError,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Observable, Subject, Subscription, throwError } from 'rxjs';
import {
  catchError,
  concatMap,
  debounceTime,
  filter,
  map,
  takeUntil,
  tap
} from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import {
  adtPaxCount,
  departureAndReturnDate,
  infantPaxCount,
  onlyDepartureDate,
  totalPaxCount,
  validateAirportCode,
  validateFromAndToAirportsForBook,
  validatonAirport
} from '../../common/error-handler/custom-validator';
import { ErrorHandlerDirective } from '../../common/error-handler/error-handler.directive';
import { FlightSearchUtils } from '../../common/flight-search/flight-search-util';
import { QueryStringHelper } from '../../common/query-string-helper';
import { NgcSelectDirective } from '../../common/select.directive';
import { ApplicationConfig } from '../../config/config';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../../corporate-partner/corporate-partner.method';
import { FlyoutModalComponent } from '../../flyout/flyout-modal/flyout-modal.component';
import { SwitchingAccountService } from '../../header/switching-account/switching-account.service';
import {
  BookFlightParameter,
  BookParameters
} from '../../model/bookparameter.model';
import { ContentAirportLookup } from '../../model/content/contentAirportLookup.model';
import { ContentBook } from '../../model/content/contentbook.model';
import { ContentFlightHotel } from '../../model/content/contentFlightHotel.model';
import { ContentHeaderFooter } from '../../model/content/contentheaderfooter.model';
import { ContentnonJVFlying } from '../../model/content/contentnonJVFlying.model';
import { GetSavedTrips } from '../../model/get-saved-trips/get-saved-trips.interfaces';
import {
  MultiCityResponse,
  RecentData,
  SearchSegmentData
} from '../../model/mc-response.interface';
import { Airports, RecentSearch } from '../../model/recent-search.model';
import {
  SavedSearchesStatus,
  SavedSearchFlags,
  SavedSearchGQLResponse
} from '../../model/saved-search/saved-search.interface';
import { SavedsearchesModel } from '../../model/savedsearches.model';
import { SearchPERequest } from '../../model/userdata-model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { TrackerDataService } from '../../services/acctactvty/trackerData.service';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { ClosestAirPortcode } from '../../services/closestairportcode.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { GetSavedTripsService } from '../../services/get-saved-trips/get-saved-trips.service';
import { MDotService } from '../../services/mdot/mdot.service';
import { isGQLEnabled } from '../../services/saved-search/saved-search-request.helper';
import { SavedSearchService } from '../../services/saved-search/saved-search.service';
import { SearchService } from '../../services/search/search.service';
import {
  UpdateAirportsActionPayload,
  UpdateDatesActionPayload
} from '../../store';
import { FormStoreDirective } from '../../store/directive/form-store.directive';
import { TriggerLoginModal } from '../login/login.interface';
import { ChildPassengerComponent } from './childPassenger/childPassenger.component';
import { FlightPlusHotelComponent } from './flight-plus-hotel/flight-plus-hotel.component';
import {
  EdocBrands,
  EdocDisableData,
  faresFor,
  iropErrorRedirect,
  SFAFFeatureFlags
} from './navigation-book.model';

export type BookWidgetState = 'visible' | 'hidden' | '';

@Component({
  selector: 'ngc-book',
  templateUrl: 'navigation-book.component.html',
  animations: [
    trigger('widgetState', [
      animationState('visible', style({})),
      animationState('hidden', style({})),
      transition('* => visible', [
        animate('400ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition('visible => hidden', [
        animate('400ms ease-out', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class NavigationBookComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  fromClosestAirportcode: any;
  fromClosestCity: string;
  customerId: string;
  savedSearch = false;
  recentSearch = false;
  flightHotelMobileSwap = false;
  savedSearches: SavedsearchesModel;
  isMeetingCodeEnter = false;
  recentSearchSelected: RecentSearch;
  recentSearches: RecentSearch[] = [];
  preferredCityChecked: boolean;
  contentServiceHeaderFooterSubscribe: Subscription;
  onChangeServiceHeaderFooterSubscribe: Subscription;
  trackerServiceRecentSearchesSubscribe: Subscription;
  trackerServiceSavedSearchesSubscribe: Subscription;
  srcClosestDeltaAirportCodeSubscribe: Subscription;
  trackerPostRecentSearchesSubscribe: Subscription;
  modalServiceOnHiddenSubscribe: Subscription;
  accountSummaryServiceSubscribe: Subscription;
  defaultLookupSubscribe: Subscription;
  storeSyncComplete: Subscription;
  showSwapSpan = false;
  passengerDropIndex = 0;
  tripTypeDropIndex = 0;
  faresForDropIndex = 0;
  @ViewChild('booksubmit')
  bookSubmitEl: ElementRef; /*jira-814, AX focus to submit button*/

  @ViewChild('meetingEventCode')
  meetingEventCodeInput: ElementRef; /*jira-814, AX focus to submit button*/

  @ViewChild(NgcSelectDirective) directive: NgcSelectDirective;
  @ViewChild('faresForDirective') faresForDirective: NgcSelectDirective;
  @ViewChild('tripTypeDropdown') tripTypeDropdown: NgcSelectDirective;
  @ViewChild('pasDropdown') pasDropdown: NgcSelectDirective;
  @ViewChild('bestFareDropdown') bestFareDropdown: NgcSelectDirective;
  @ViewChild('flightPlusHotelComponent')
  flightPlusHotelComponent: FlightPlusHotelComponent;

  @ViewChild(ChildPassengerComponent)
  childPassengerComponent: ChildPassengerComponent;

  @ViewChild('mpmForm') mpmForm: ElementRef;
  /**
   * isShoppingAwsFlow is sent by ng-book of aws shopping slice SFAF
   * to make changes in html so that it supports angular12 events and syntaxs
   */
  @Input() isShoppingAwsFlow = false;
  @Input() isInAdvanceSearch = false;
  @Input() nextgenPage = false;
  @Input() isModifiedFromNavBar = false;
  @Input() cacheKeySuffix = ''; // Edoc Fix
  cacheKeySuffixVal = ''; // EDOC RSB13179
  /*
   * If an api call marks an airport code as invalid,
   * this array is updated to validate airport code input values against it
   */
  @Input() invalidAirportCodes: string[] = [];
  @Input() isWidgetAlwaysExpanded: boolean;
  @Input() prefCity;
  @Input() airPortForOdPair;
  @Input() toAirportOdPair;
  @Input() custId;
  @Input() mobileNav = false;
  @Input() isEDPFlag;
  @Input() corpPartner: ICorporatePartner;
  @Input() inMobile: boolean;
  @Input() recentSelected: RecentSearch;
  @Input() savedSelected: any;
  @Output() expandClicked: EventEmitter<any> = new EventEmitter();
  @Output() errorPresent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() xButtonClicked: EventEmitter<any> = new EventEmitter();
  // input flags from Shopping for eDoc restriction changes and the values has been set by default for local testing
  @Input() isEdocApplied = false;
  @Input() disabledByEdocData: EdocDisableData;
  @Input() triggerDefaultLookupEvent: any;
  @Input() isloggedIn = false;
  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onAirportSelected: EventEmitter<any> = new EventEmitter();

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFromAirportSelected: EventEmitter<any> = new EventEmitter();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onToAirportSelected: EventEmitter<any> = new EventEmitter();
  @Input() fromAirport: any;
  @Input() toAirport: any;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFromAirportSearched: EventEmitter<string> = new EventEmitter();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onToAirportSearched: EventEmitter<string> = new EventEmitter();
  @Input() clickedOutside: boolean;
  @Input() mkcpgn: string;
  @Input() queryParam: BookParameters;
  @Input() shopExperience: any;
  @Input() advanchedSearchClicked: boolean;
  @Input() businessAccountOptionsList =
    this.switchingAccountService.initializeViewData();

  @Input() widgetOnTop = false;
  @Input() canBookNonRefundable: string;
  @Input() widgetTopPosition: string;
  enableCloseButton: boolean;
  updateExecutedForAdvSearch = false;
  savedSearchesAvailable = false;
  recentSearchsAvailable = false;
  @ViewChild(ErrorHandlerDirective) errorHandler: ErrorHandlerDirective;
  @ViewChild('formStoreDir') formStoreDir: FormStoreDirective;
  isSubmitted: boolean;
  prefCityVal = '';
  isLoggedInFlag = false;
  showErrorFromAirport = false;
  showErrorToAirport = false;
  meetingEvntCdFlag = false;
  showEdpMeetingEvtMsg = true;
  edpMeetingCodeEventMessage = '';
  deviceTypeSubscribe: Subscription;
  childPassenger = false;
  detailPassenger: any[] = [];
  searchPrefillFlag = false;
  prefillClosestAirport = false;
  isReady = false;
  airportLookupContent: ContentAirportLookup;
  odPairRestriction: string;
  isInterceptModalRequired: string;
  oldTripType = 'ROUND_TRIP';
  vaPaxDropDown = false;
  adtCount: any;
  gbeCount: any;
  cnnCount: any;
  infCount: any;
  flightHotelContent: ContentFlightHotel;
  nonJVFlyingContent: ContentnonJVFlying;
  flightplushotelduration: string;
  tempDestinationCity: string;
  moveFocusTo: any;
  moveFocusToLogged: any;
  basicEconomy = '';
  @Output()
  advSearchExpanded = new EventEmitter<boolean>();

  @Input() fromShopHeader: boolean;
  @Input() sendRecentSearch: any;
  @Input() widgetState = '';
  bookWidgetForm: UntypedFormGroup;
  selectTripType = 'ROUND_TRIP';
  fromAirportcode = '';
  restrictMpm = '';
  fromCity = '';
  swapedFromCity = '';
  swapedToCity = '';
  toAirportcode = '';
  toCity = '';
  schedulePrice = 'price';
  isWidgetExpanded = false;
  isAdvSearchExpanded = false;
  isFlightPlusHotelChecked = false;
  isAdvSearchAnimationDone = false;
  faresFor = faresFor;
  passenger = '';
  fareClass = '';
  forHiddendepartureDate = '';
  forHiddenreturnDate = '';
  forHiddencabinFareClass = '';
  forHiddenMulticityFlightsLength: any;
  deviceTypes: any = [];
  bookSubmitUrl: string;
  isMobSafari = false;
  awardTravel = false;
  mpmTravel = true;
  flightPlusHotel = false;
  nonJvPartner = false;
  restrictmpmTravel = false;
  restrictMiles = false;
  restrictCash = false;
  tooltipValue = 'show-price-in';
  restrictNonJvPartner = true;
  restrictFlightHotel = true;
  restrictFlightHotelOrig = true;
  flightHotelDest = '';
  actionUrl = '/flight-search/search';
  actionMethod = 'GET';
  actionChangeFlag = true;
  loginPageURL: string;
  refreshURL: string;
  airlineCode: any;
  content: ContentBook;
  brandBEIndex: any;
  brandBE: any;
  brands: any;
  uiTripTypes: any;
  multiCityIndex: any;
  multiCity: any;
  fromAirportLabel = '';
  toAirportLabel = '';
  triptypeIndex: any = 0;
  paxIndex: any = 0;
  fareIndex: any = 0;
  edpMeetingCodeDisclaimerList: any = {};
  meetingInlineTextCodeList: any;
  meetingInlineTextCodeData: any = [];
  isFlexDate: any = false;
  isFlexAirPort: any = false;
  date: any;
  disableMulityCity = false;
  issetSavedSearchesAirport = false;
  loginUrl = '';
  isMilesMobileRedirect = false;
  disableTripType = false;
  isBusiness = false;
  disablePaxDropDown = false;
  eDocPassengerArray = [];
  timeouts = [];
  player: AnimationPlayer;
  viewInitializedCheck: boolean;
  isMultiPax = false;
  isDisableIntercept = false;
  recentlySearchedMulticityData: any;
  deepLinkVendorId: string;
  showNewProfileSelector = false;
  profileSelectorEnableMilesFlag = false;
  restrictNewPaxToOne = false;
  isSFAF = false;
  generateCacheKey = false;
  newProfileSelectorDisplayInlineText = '';
  businessList = {
    isOaSmeAccount: '',
    partnerId: '',
    accountIndex: 0,
    restrictPaxToOne: false,
    displayInlineText: '',
    disableMiles: false
  };

  fromCountryCode = '';
  toCountryCode = '';
  SFAFCookiesName = 'SFAFFlowRouterCookie';
  CURRENT_APP_NAME = '';
  sfafFeatureFlags: SFAFFeatureFlags = {
    enableSFAFFlexAirports: false,
    enableSFAFFlexDatesAndCalendar: false,
    enableSFAFFlexDatesAndCalendarWithLogin: false,
    enableSFAFDDCFB: false
  };

  clearCKOCookie = false;
  callSavedSearchInitiated = false;
  headerFooter: Partial<ContentHeaderFooter> = null;
  getSavedTripsFlag = false;
  private unsubscribe: Subject<void> = new Subject();
  private animationTime = '300ms';
  private isAnimationPlaying = false;
  private isViewInitialized = false;
  @ViewChild('advSearchContainer') private advSearchContainer: ElementRef;
  iropServiceSubscribe: Subscription;
  shopWithMilesClicked = false;

  constructor(
    private el: ElementRef,
    private fb: UntypedFormBuilder,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    private cdf: ChangeDetectorRef,
    private srv: CommonService,
    private srvClosestAirport: ClosestAirPortcode,
    private contentService: ContentHeaderFooterService,
    private formBuilder: UntypedFormBuilder,
    private trackerDataService: TrackerDataService,
    private savedSearchService: SavedSearchService,
    private ren: Renderer2,
    private srvMDot: MDotService,
    private datalayer: DataLayer,
    private config: ApplicationConfig,
    private _builder: AnimationBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _deviceTypeHelper: DeviceTypeHelper,
    private _route: ActivatedRoute,
    public switchingAccountService: SwitchingAccountService,
    private searchService: SearchService,
    public cookieHelper: CookieHelper,
    private cache: TransferState,
    private store: Store<any>,
    private accountSummaryService: AccountSummaryService,
    private flightSearchUtils: FlightSearchUtils,
    private queryStringHelper: QueryStringHelper,
    private userSession: UserSessionService,
    private loggingService: LoggingService,
    private userData: UserDataService,
    private analytics: AdobeDataLayerService,
    private getSaveTrips: GetSavedTripsService,
    private iropService: IropService
  ) {}

  @HostListener('document:keydown', ['$event']) onkeydown(event) {
    if (event.target && event.target.id && event.target.id === 'meetingCode') {
      this.onEnterMeetingCode();
    }
  }

  getQueryParams(queryParamName: string) {
    let queryParamValue;
    if (
      this._route.snapshot.queryParams &&
      this._route.snapshot.queryParams[queryParamName] !== undefined &&
      this._route.snapshot.queryParams[queryParamName] !== null
    ) {
      queryParamValue = this._route.snapshot.queryParams[queryParamName];
    } else {
      queryParamValue = undefined;
    }
    if (!queryParamValue) {
      queryParamValue =
        this.queryStringHelper.getParameterByName(queryParamName);
    }
    return queryParamValue;
  }

  toggleWidget() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.widgetTopPosition === 'fixed') {
        const event = new CustomEvent('minimize-button-click', {
          bubbles: true
        });
        document.dispatchEvent(event);
      }
    }
    this.bookWidgetForm
      .get('selectTripType')
      .setValue(this.recentSearchSelected.selectTripType);
    this.xButtonClicked.emit();
    this.cdf.detectChanges();
  }

  ngOnInit() {
    if (this.config.onBrowser) {
      this.meetingInlineTextCodeList =
        this.config.get('APP_MEETING_INLINE_TEXT') || null;
      this.CURRENT_APP_NAME = this.config.get('APP') || '';
      this.setMeetingCodeData();
      this.setRecentSearchesAirport();
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
      this.isMobSafari = this.isSafariMobile();
      // this will happen in case of Advance Search for start Over and lookup scenario from checkout
      this.setDeepLinkVendor();
    }
    // if (this.config.onBrowser) {
    //   this.setRecentSearchesAirport();
    // }

    this.bookWidgetForm = this.formBuilder.group({
      airports: this.formBuilder.group(
        {
          fromCity: new UntypedFormControl({ value: this.fromCity }),
          toCity: new UntypedFormControl({ value: this.toCity }),
          fromAirportcode: [
            this.fromAirportcode,
            [validatonAirport, validateAirportCode]
          ],
          toAirportcode: [
            this.toAirportcode,
            [validatonAirport, validateAirportCode]
          ],
          invalidAirportCodes: new UntypedFormControl(),
          fromCountryCode: new UntypedFormControl(this.fromCountryCode),
          toCountryCode: new UntypedFormControl(this.toCountryCode)
        },
        {
          validator: validateFromAndToAirportsForBook(
            'fromAirportcode',
            'toAirportcode'
          )
        }
      ),
      selectTripType: new UntypedFormControl(),
      dates: this.formBuilder.group(
        {
          departureDate: ['', Validators.pattern('^[a-zA-Z0-9 -//]*$')],
          returnDate: ['', Validators.pattern('^[a-zA-Z0-9 -//]*$')],
          chkFlexDate: new UntypedFormControl(false)
        },
        { validator: departureAndReturnDate('departureDate', 'returnDate') }
      ),
      passenger: new UntypedFormControl(),
      swapedFromCity: new UntypedFormControl(),
      swapedToCity: new UntypedFormControl(),
      schedulePrice: new UntypedFormControl({ value: this.schedulePrice }),
      flightHotelDeals: new UntypedFormControl(),
      faresFor: new UntypedFormControl(),
      meetingEventCode: [
        '',
        [Validators.maxLength(5), Validators.pattern('^[a-zA-Z0-9]*$')]
      ],
      refundableFlightsOnly: new UntypedFormControl(),
      nearbyAirports: new UntypedFormControl(),
      deltaOnly: new UntypedFormControl(),
      awardTravel: new UntypedFormControl(),
      departureTime: new UntypedFormControl(),
      returnTime: new UntypedFormControl(),
      adtGbeCount: new UntypedFormControl(),
      infantCount: new UntypedFormControl(),
      maxPaxCount: new UntypedFormControl(),
      adtCount: new UntypedFormControl(),
      cnnCount: new UntypedFormControl(),
      gbeCount: new UntypedFormControl(),
      chkFlexDate: new UntypedFormControl(false),
      basicFaresField: new UntypedFormControl(true)
    });

    if (
      this.corpPartner.name === 'default' ||
      this.corpPartner.name === 'personal'
    ) {
      this.setCorpPartner();
    }

    if (
      this.switchingAccountService.businessAccount ||
      this.corpPartner.disableMiles ||
      this.restrictMiles
    ) {
      if (
        document.querySelector('#milesLabel') &&
        !document
          .querySelector('#milesLabel')
          .classList.contains('disabledTextMile')
      ) {
        document.querySelector('#milesLabel').classList.add('disabledTextMile');
      }
    } else {
      if (
        document.querySelector('#milesLabel') &&
        document
          .querySelector('#milesLabel')
          .classList.contains('disabledTextMile')
      ) {
        document
          .querySelector('#milesLabel')
          .classList.remove('disabledTextMile');
      }
    }
    if (this.config.get('APP_OLD_SHOP_BOOK') === 'true') {
      this.actionMethod = 'POST';
      this.actionUrl = '/air-shopping/findFlights.action';
    }
    if (this.config.get('APP_BE_BRAND') !== '') {
      this.basicEconomy = this.config.get('APP_BE_BRAND');
    }
    this.searchPrefillFlag =
      this.queryParam !== undefined && this.queryParam.isQueryParam
        ? true
        : false;
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (
            this.config.onBrowser &&
            this.contentService.contentHeaderFooter
          ) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    this.headerFooter = data;
                    this.showNewProfileSelector =
                      !!data.header.enableNewProfileSelector;
                    this.profileSelectorEnableMilesFlag =
                      data.header.enableMilesNewProfileSelector;
                    if (this.showNewProfileSelector) {
                      this.setBusinessOption();
                    }
                    if (data && data.header.primaryNavigations.get('book')) {
                      this.content =
                        data.header.primaryNavigations.get('book').details;
                      this.flightHotelContent = data.flightPlusHotel;
                      this.nonJVFlyingContent = data.nonJVFlying;
                      this.flightplushotelduration =
                        this.content.flightplushotelduration;
                      this.edpMeetingCodeDisclaimerList[
                        'edpMeetingCodeDisclaimer'
                      ] = this.content.edpMeetingCodeDisclaimer
                        ? this.content.edpMeetingCodeDisclaimer
                        : '';
                      this.edpMeetingCodeDisclaimerList[
                        'edpMeetingCodeDisclaimerForFare'
                      ] = this.content.edpMeetingCodeDisclaimerForFare
                        ? this.content.edpMeetingCodeDisclaimerForFare
                        : '';
                      this.edpMeetingCodeDisclaimerList[
                        'edpMeetingCodeDisclaimerForProgram'
                      ] = this.content.edpMeetingCodeDisclaimerForProgram
                        ? this.content.edpMeetingCodeDisclaimerForProgram
                        : '';
                      this.edpMeetingCodeDisclaimerList[
                        'edpMeetingCodeDisclaimerForNoProgram'
                      ] = this.content.edpMeetingCodeDisclaimerForNoProgram
                        ? this.content.edpMeetingCodeDisclaimerForNoProgram
                        : '';
                      this.edpMeetingCodeEventMessage =
                        this.setEdpMeetingEventCodeMessage();
                      this.bookSubmitUrl = this.content.submitUrl;
                      if (this.basicEconomy !== '') {
                        this.brandBEIndex = Object.keys(
                          this.content.brands
                        ).findIndex(
                          (key) =>
                            this.content.brands[key].brandId ===
                            this.basicEconomy
                        );
                        this.brandBE = this.content.brands[this.brandBEIndex];
                      }
                      this.brands = Object.assign([], this.content.brands);
                      if (this._enableBasicFareFeature()) {
                        this.brands = this.brands.filter(
                          (brand) => brand.brandId !== 'BE'
                        );
                      }
                      this.uiTripTypes = Object.assign(
                        [],
                        this.content.tripTypes
                      );
                      this.multiCityIndex = Object.keys(
                        this.content.tripTypes
                      ).findIndex(
                        (key) =>
                          this.content.tripTypes[key].tripTypeValue ===
                          'MULTICITY'
                      );
                      this.multiCity =
                        this.content.tripTypes[this.multiCityIndex];
                      this.setAemValues();
                      this.setPaxDropDownByEdoc();
                      if (this.searchPrefillFlag) {
                        this.searchWidgetPrefilling();
                      }
                      this.setFlightPlusHotel();
                      this.setMPMTravel();
                      this.setMilesMobileRedirect();
                      this.airportLookupContent = data.airportLookup;
                      this.odPairRestriction =
                        this.airportLookupContent.odPairRestriction;
                      this.isInterceptModalRequired =
                        this.airportLookupContent.isInterceptModalRequired;
                      if (
                        this.odPairRestriction !== undefined &&
                        this.odPairRestriction.toLowerCase() === 'true' &&
                        this.bsModalRef !== undefined &&
                        this.bsModalRef.content !== undefined &&
                        this.bsModalRef.content.airPortForOdPair !==
                          undefined &&
                        this.bsModalRef.content.toAirportOdPair !== undefined
                      ) {
                        this.toAirportcode =
                          this.bsModalRef.content.toAirportOdPair;
                        this.setODPairRestrictions(
                          this.bsModalRef.content.airPortForOdPair
                        );
                      }
                      if (this.content.passengertype.length !== 0) {
                        this.vaPaxDropDown = true;
                        this.setMaxPassenger();
                      }
                      this.cdf.detectChanges();
                      this.viewInitializedCheck = false;
                      this.rebindDropdowns();
                      if (this.vaPaxDropDown) {
                        this.cdf.detectChanges();
                      }
                      this.isReady = true;
                      this.getOdPairAttributes();
                    }
                    this.isSFAF = data.header.triggerLoginModal
                      ? this._getSFAFEnabled(data.header.triggerLoginModal)
                      : false;

                    this.generateCacheKey = data.header.triggerLoginModal
                      ? this._getGenerateCacheLey(data.header.triggerLoginModal)
                      : false;

                    this.srv.shoppingOptimization =
                      this.getShoppingOptimization(
                        data.header.triggerLoginModal
                      );

                    this.configureSFAFFeatureFlags(
                      data.header.triggerLoginModal
                    );

                    this.setBookSubmitUrl();
                    this.showMobileMultiPax();
                    if (data) {
                      const auxiliaryNavArr = Array.from(
                        data.header.auxiliaryNavigation.values()
                      );
                      for (const item of auxiliaryNavArr) {
                        const key = item['id'];
                        if (key === 'login') {
                          this.loginUrl = item['details'].loginLink;
                        }
                      }
                    }
                  },
                  (err) => {
                    this.loggingService.log('Caught Error: ' + err);
                  }
                );
            this.isDisableIntercept =
              this.config.get('APP_SHOP_HEADER') !== undefined &&
              this.config.get('APP_SHOP_HEADER') === 'true'
                ? true
                : false;
          }
        }
      });
    this.switchingAccountService.corporatePartnerChange.subscribe(
      (corpPartner: ICorporatePartner) => {
        this.corpPartner = corpPartner;
        const account =
          this.switchingAccountService.getAccountCookie('account');
        const hipmunkCookie =
          this.cookieHelper.getCookieValue('isHipmunk') !== null
            ? this.cookieHelper.getCookieValue('isHipmunk')
            : false;
        if (account?.length) {
          const parseAccount = JSON.parse(account);
          this.businessAccountOptionsList =
            parseAccount['businessAccountOptionsList'];
        }
        if (hipmunkCookie === 'true' || hipmunkCookie) {
          this.corpPartner = getCorporatePartner('hipmunk');
        }
        this.edpMeetingCodeEventMessage = this.setEdpMeetingEventCodeMessage();
        if (
          (this.corpPartner.disableMiles || this.restrictMiles) &&
          this.bookWidgetForm.get('schedulePrice') &&
          this.bookWidgetForm.get('schedulePrice').value === 'miles'
        ) {
          this.setAwardTravel('price');
          this.bookWidgetForm.get('schedulePrice').setValue('price');
        }
        if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
          this.disablePassengerDropdown();
        } else {
          this.enablePassengerDropDown();
        }
        this.cdf.detectChanges();
        if (this.pasDropdown) {
          this.pasDropdown.reBind();
        }
      }
    );
    if (this.fromShopHeader || this.isInAdvanceSearch) {
      this.getAccountData();
      if (this.bookWidgetForm && this.sendRecentSearch !== undefined) {
        this.setRecentSearchResults(this.sendRecentSearch);
      }
    }
    const newDepartDate = this.bookWidgetForm.get('dates.departureDate').value;
    if (
      newDepartDate !== null &&
      newDepartDate !== undefined &&
      newDepartDate !== ''
    ) {
      this.forHiddendepartureDate = this.formateDate(newDepartDate);
    }
    const newReturnDate = this.bookWidgetForm.get('dates.returnDate').value;
    if (
      newReturnDate !== null &&
      newReturnDate !== undefined &&
      newReturnDate !== ''
    ) {
      this.forHiddenreturnDate = this.formateDate(newReturnDate);
    }

    this.checkForCKOCoookie();
    this.getSavedTripsFeatureFlag();
  }

  checkForCKOCoookie() {
    try {
      this.userData.getAuthConfigContent().subscribe((response) => {
        if (response && response['CLEAR_CKO_COOKIE'] === true) {
          this.clearCKOCookie = response['CLEAR_CKO_COOKIE'];
        } else {
          this.clearCKOCookie = false;
        }
      });
    } catch (error) {
      this.loggingService.log('Error Reading CKO Feature Flags');
    }
  }

  setMeetingCodeData() {
    if (this.meetingInlineTextCodeList) {
      const meetingInlineTextCodeListArr =
        this.meetingInlineTextCodeList.split(',');
      meetingInlineTextCodeListArr.forEach((meetingCodeKey) => {
        const tempKey = meetingCodeKey.split(':')[0];
        const tempVal = meetingCodeKey.split(':')[1];
        this.meetingInlineTextCodeData[tempKey] = tempVal;
      });
    } else {
      this.meetingInlineTextCodeData = null;
    }
  }

  setBusinessOption() {
    const accountCookie = this.cookieHelper.getCookieValue('account');
    if (accountCookie && accountCookie.length) {
      const accountCookieJson = JSON.parse(accountCookie);
      if (accountCookieJson['isBusiness']) {
        this.businessList = accountCookieJson['businessAccountOptionsList'];
        this.isBusiness = true;
        this.restrictNewPaxToOne = this.businessList.restrictPaxToOne;
        this.restrictMiles = this.businessList.disableMiles;
      }
      this.newProfileSelectorDisplayInlineText =
        this.businessList.displayInlineText;
    }
  }

  isExists(data) {
    return data !== undefined && data !== null;
  }

  triggerDefaultLookup() {
    this.defaultLookupSubscribe = this.srv
      .getDefaultsAndLookup(this.getCacheKeySuffix())
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (
          data &&
          data.searchCriteria &&
          data.searchCriteria.useEdocDefaultPaxCount
        ) {
          this.disabledByEdocData = {
            EdocTripTypeObj: [],
            disablePaxDropDown: false,
            disableShowPriceIn: false,
            disableBestFaresFor: false,
            disableMeetingCode: false,
            disableRefundableFares: false,
            disableNearbyAirport: false,
            disableEdocLink: false,
            disableFlexibleDates: 'false',
            eDocTripType: 'ROUND_TRIP',
            eDocPaxCount: 1,
            eDocMinPaxCount: 1,
            eDocMaxPaxCount: 9,
            bestFaresFor: [],
            hideBasicFares: false
          };
          if (
            data !== null &&
            data !== undefined &&
            data.searchCriteria !== undefined
          ) {
            if (
              this.isExists(data.searchCriteria.disableTripType) &&
              this.isExists(data.searchCriteria.disablePaxDropDown) &&
              this.isExists(data.searchCriteria.disableShowPriceIn) &&
              this.isExists(data.searchCriteria.disableBestFaresFor) &&
              this.isExists(data.searchCriteria.disableMeetingCode) &&
              this.isExists(data.searchCriteria.disableRefundableFares) &&
              this.isExists(data.searchCriteria.disableNearbyAirport) &&
              this.isExists(data.searchCriteria.disableEdocLink) &&
              this.isExists(data.searchCriteria.disableFlexibleDates) &&
              this.isExists(data.searchCriteria.useEdocDefaultPaxCount) &&
              this.isExists(data.searchCriteria.fareBrandsByMoney)
            ) {
              // this.disabledByEdocData.disableTripType = data.searchCriteria.disableTripType;
              // useEdocDefaultPaxCount is the flag by BFF to identify if eDocPaxCount has to be set to this as default. So not using disablePaxDropDown as it is not set properly by BFF
              this.disabledByEdocData.hideBasicFares =
                data.searchCriteria.hideBasicFares;
              this.disabledByEdocData.disablePaxDropDown =
                data.searchCriteria.useEdocDefaultPaxCount;
              this.disabledByEdocData.disableShowPriceIn =
                data.searchCriteria.disableShowPriceIn;
              this.disabledByEdocData.disableBestFaresFor =
                data.searchCriteria.disableBestFaresFor;
              this.disabledByEdocData.disableMeetingCode =
                data.searchCriteria.disableMeetingCode;
              this.disabledByEdocData.disableRefundableFares =
                data.searchCriteria.disableRefundableFares;
              this.disabledByEdocData.disableNearbyAirport =
                data.searchCriteria.disableNearbyAirport;
              this.disabledByEdocData.disableEdocLink =
                data.searchCriteria.disableEdocLink;
              this.disabledByEdocData.disableFlexibleDates = data.searchCriteria
                .disableFlexibleDates
                ? 'true'
                : 'false';
              // this.disabledByEdocData.bestFaresFor = data.searchCriteria.fareBrandsByMoney;
              if (data.searchCriteria.fareBrandsByMoney.length > 0) {
                data.searchCriteria.fareBrandsByMoney.forEach(
                  (brand, brandIndex) => {
                    const brandfare: EdocBrands = {
                      brandId: '',
                      brandTitle: ''
                    };
                    brandfare.brandId = brand.brandID;
                    brandfare.brandTitle = brand.brandName;
                    this.disabledByEdocData.bestFaresFor.push(brandfare);
                  }
                );
              }
              if (this.isExists(data.searchCriteria.edocDefaultPaxCount)) {
                this.disabledByEdocData.eDocPaxCount =
                  data.searchCriteria.edocDefaultPaxCount;
              }
              if (
                this.isExists(data.searchCriteria.journeyTypeOptions) &&
                data.searchCriteria.journeyTypeOptions.length > 0
              ) {
                this.disabledByEdocData.EdocTripTypeObj =
                  data.searchCriteria.journeyTypeOptions;
              }
              if (
                this.isExists(data.searchCriteria.edocMinPaxCount) &&
                this.isExists(data.searchCriteria.edocMaxPaxCount)
              ) {
                this.disabledByEdocData.eDocMinPaxCount =
                  data.searchCriteria.edocMinPaxCount;
                this.disabledByEdocData.eDocMaxPaxCount =
                  data.searchCriteria.edocMaxPaxCount;
              }
              this.isEdocApplied = true;
              this.setEdocValues();
            }
          }
          this.cdf.detectChanges();
        } else if (
          data &&
          data.searchCriteria &&
          !data.searchCriteria.useEdocDefaultPaxCount
        ) {
          this.isEdocApplied = false;
          this.updDispValuesForAdvSearch();
          this.cdf.detectChanges();
        }
      });
  }

  getAccountData() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.userSession.getServiceWorkerCheck()) {
        this.getAccountDataHelper();
      }
    }
  }

  getAccountDataHelper() {
    this.accountSummaryServiceSubscribe = this.accountSummaryService
      .getAccountSummaryDetails()
      .pipe(debounceTime(500))
      .subscribe(
        (data) => {
          if (data) {
            if (data && data['smNumber']) {
              this.custId = data['smNumber'];
              this.customerId = this.custId;
              this.canBookNonRefundable = data['canBookNonRefundable'];
            }
          } else {
            // console.log('In getAccoutnData 3');
          }
        },
        (err) => {
          if (err) {
            console.log('Error');
          }
        }
      );
  }

  captureUIUpdates() {
    this.store
      .select((state) => state?.slimNavReducer?.airportChanges)
      .subscribe(
        (values: UpdateAirportsActionPayload) => {
          if (values && values.fromCity && values.toCity) {
            this.fromAirportcode = values.fromCity;
            this.fromCity = values.fromCityName;
            this.toAirportcode = values.toCity;
            this.toCity = values.toCityName;
            this.cdf.detectChanges();
          } else if (this.mobileNav) {
            this.fromAirportcode = this.bsModalRef.content.fromAirportcode;
            this.fromCity = this.bsModalRef.content.fromCity;
            this.toAirportcode = this.bsModalRef.content.toAirportcode;
            this.toCity = this.bsModalRef.content.toCity;
            this.fromCountryCode = this.bsModalRef.content.fromCountryCode;
            this.toCountryCode = this.bsModalRef.content.toCountryCode;
            this.bsModalRef.content.mobileNav = false;
          }
        },
        (err) => {
          this.loggingService.log(
            `captureUIUpdates state.slimNavReducer.airportChanges subscription returned the following  error ${err}`
          );
        }
      );
    this.store
      .select((state) => state?.slimNavReducer?.dateChanges)
      .subscribe(
        (values: UpdateDatesActionPayload) => {
          if (values && values.departDate) {
            this.bookWidgetForm
              .get('dates.departureDate')
              .setValue(values.departDate);
            this.bookWidgetForm
              .get('dates.returnDate')
              .setValue(values.returnDate);
            this.forHiddendepartureDate = this.formateDate(values.departDate);
            this.forHiddenreturnDate =
              values.returnDate && values.returnDate.length
                ? this.formateDate(values.returnDate)
                : '';
            this.cdf.detectChanges();
          }
        },
        (err) => {
          this.loggingService.log(
            `captureUIUpdates state.slimNavReducer.dateChanges subscription returned the following  error ${err}`
          );
        }
      );
  }

  isSafariMobile() {
    const browserData = window.navigator.userAgent;
    const iOSdata = browserData.match(/iPhone/i);
    const webkitData = browserData.match(/WebKit/i);
    const isiOSSafari = iOSdata && webkitData && !browserData.match(/CriOS/i);
    return isiOSSafari;
  }

  stopTimeout() {
    for (let id = 0; id < this.timeouts.length; id++)
      clearTimeout(this.timeouts[id]);
    this.timeouts = [];
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.onChangeServiceHeaderFooterSubscribe) {
      this.onChangeServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.trackerServiceRecentSearchesSubscribe) {
      this.trackerServiceRecentSearchesSubscribe.unsubscribe();
    }
    if (this.iropServiceSubscribe) {
      this.iropServiceSubscribe.unsubscribe();
    }
    if (this.trackerServiceSavedSearchesSubscribe) {
      this.trackerServiceSavedSearchesSubscribe.unsubscribe();
    }
    if (this.srcClosestDeltaAirportCodeSubscribe) {
      this.srcClosestDeltaAirportCodeSubscribe.unsubscribe();
    }
    if (this.trackerPostRecentSearchesSubscribe) {
      this.trackerPostRecentSearchesSubscribe.unsubscribe();
    }
    if (this.storeSyncComplete) {
      this.storeSyncComplete.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }

    this.stopTimeout();
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.cdf.detach();

    if (this.config.onBrowser) {
      const mobileWidgetScrollableContainer = document.getElementsByClassName(
        'mobile-widget-scrollable-container'
      )[0];
      if (
        mobileWidgetScrollableContainer !== undefined &&
        mobileWidgetScrollableContainer !== null
      ) {
        mobileWidgetScrollableContainer.classList.remove(
          'mobile-widget-multicity-container'
        );
      }
    }
    if (this.deviceTypeSubscribe) {
      this.deviceTypeSubscribe.unsubscribe();
    }
  }

  displayRecentSearch(val) {
    if (this.bookWidgetForm) {
      this.setRecentSearchResults(val);
      if (this.vaPaxDropDown) {
        this.childPassengerComponent.setRecentSearchPassenger(val);
      }
    }
  }

  refundableCheckboxDdcfb(): boolean {
    const accountCookie = this.cookieHelper.getCookieValue('account');
    if (this.canBookNonRefundable && accountCookie && accountCookie.length) {
      const accountCookieJson = JSON.parse(accountCookie);
      const canBookNonRefundableList = this.canBookNonRefundable.split('|');
      if (
        (canBookNonRefundableList[
          accountCookie.charAt(accountCookie.length - 3)
        ] === 'false' ||
          canBookNonRefundableList[
            accountCookieJson['businessAccountOptionsList'].accountIndex
          ] === 'false') &&
        accountCookieJson['isBusiness']
      ) {
        return true;
      }
    }
    return false;
  }

  setSaved(val) {
    this.fromAirportcode = val.origDestInfos[0].originCityCd;
    this.fromCity = '';
    this.toAirportcode = val.origDestInfos[0].destinationCityCd;
    this.toCity = '';
    if (!this.isEdocApplied) {
      if (val.tripType !== null) {
        this.setTripType(val.tripType);
      } else {
        this.setTripType('ROUND_TRIP');
      }
    }

    this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(
      this.refundableCheckboxDdcfb() || val.isRefundable ? true : false
    );
    this.awardTravel = val.isRedeemMiles || this.shopWithMilesClicked;
    this.bookWidgetForm
      .get('schedulePrice')
      .setValue(
        val.isRedeemMiles || this.shopWithMilesClicked ? 'miles' : 'price'
      );
    this.bookWidgetForm.controls['chkFlexDate'].setValue(false);
    if (val.isRedeemMiles === true || this.shopWithMilesClicked) {
      this.setAwardTravel('miles');
    } else {
      this.setAwardTravel('price');
    }
    this.bookWidgetForm.controls['nearbyAirports'].setValue(false);
    this.setFlexAirport();
    this.bookWidgetForm.get('meetingEventCode').setValue('');
    this.triptypeIndex = this.getTripTypeIndex(val.tripType);
    this.paxIndex = (val.numberOfPassengers - 1).toString();
    this.passenger = val.numberOfPassengers.toString();
    if (this.vaPaxDropDown) {
      this.childPassengerComponent.setSavedSearchPassengers(this.passenger);
    }
    this.setPaxDropDownByEdoc();
    this.bookWidgetForm.get('dates.departureDate').setValue('');
    if (this.selectTripType === 'ROUND_TRIP') {
      this.bookWidgetForm.get('dates.returnDate').setValue('');
    }

    if (
      !this.disabledByEdocData?.disableBestFaresFor &&
      this.content?.brands?.length > 0
    ) {
      if (val.cabin && val.cabin !== null && val.cabin !== undefined) {
        this.fareIndex = 0;
        for (let index = 0; index < this.content.brands.length; index++) {
          if (
            this.content.brands[index].brandId.toUpperCase() ===
            val.cabin.toUpperCase()
          ) {
            this.fareClass = this.content.brands[index].brandId;
            if (this.config.get('APP_BE_BRAND') === '') {
              this.fareIndex = index;
            } else {
              this.fareIndex = this.awardTravel ? index - 1 : index;
            }
          }
        }
      } else {
        this.fareIndex = 0;
      }
    }
    if (this.deviceTypes.isDesktop) {
      this.setSelectText(
        '#selectTripType-val',
        '#selectTripType-desc',
        this.triptypeIndex
      );
      this.setSelectText('#passengers-val', '#passengers-desc', this.paxIndex);
      this.setSelectText('#faresFor-val', '#faresFor-desc', this.fareIndex);
    }
    this.cdf.detectChanges();
    this.getOdPairAttributes();
  }

  async setRecentSearchesAirport() {
    let callsetSavedSearches = false;
    const recentSearchCallParams = this.getRecentSearchCallParams();
    this.setODPairAttributes();
    this.trackerServiceRecentSearchesSubscribe =
      recentSearchCallParams.serviceCall
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            if (res !== null && res !== undefined && res !== '') {
              if (recentSearchCallParams.multicity && res.value) {
                res = [res.value];
              }
              if (res.length > 0) {
                if (
                  this.recentSearches?.length < 1 &&
                  this.issetSavedSearchesAirport === true
                ) {
                  callsetSavedSearches = true;
                }

                res.forEach((resp) => {
                  this.recentSearches.push(new RecentSearch(resp));
                });
                if (this.recentSearches.length > 0) {
                  this.recentSearchSelected = this.recentSearches[0];
                  this.recentSearchsAvailable = true;
                  this.updDispValuesForAdvSearch();
                }
              }
            }
          },
          (err) => {
            const exception =
              err && err['message'] ? err['message'] : 'unknown exception';
            const errMessage = `setRecentSearchesAirport call to recent search returned following error ${exception}`;
            this.loggingService.log(errMessage);
          }
        );
  }

  ngAfterViewInit(): void {
    if (this.bookWidgetForm && this.sendRecentSearch !== undefined) {
      this.setBusinessOption();
      this.captureUIUpdates();
    }
    if (!this.isModifiedFromNavBar) {
      this.setStoreValues(); // TODO  commented and added back in ngAfterView init for shopping slice . This store will be removed in Feb
    }
    // this.setClosestAirport();
    if (this.isWidgetAlwaysExpanded) {
      this.isWidgetExpanded = true;
    }
    this.isViewInitialized = true;
    if (!this.viewInitializedCheck) {
      this.rebindDropdowns();
    }
    // this.setSavedSearchesAirport(this.customerId);
    // if (this.bookWidgetForm !== undefined)
    //   this.cdf.detectChanges();
    if (
      this.bookWidgetForm !== undefined &&
      this.prefillClosestAirport &&
      this.searchPrefillFlag &&
      !this.isInAdvanceSearch
    ) {
      this.schedulePrice = 'milesplusmoney';
      this.bookWidgetForm.get('schedulePrice').setValue('milesplusmoney');
    }
    this.updDispValuesForAdvSearch();
    this.updateInvalidAirportCodes();
    this.setEdocValues();
    if (this.getQueryParams('rewardticket')) {
      this.schedulePrice = 'miles';
      this.bookWidgetForm.get('schedulePrice').setValue('miles');
      this.setAwardTravel('miles');
    }
  }

  /*
   * To update with previous search fields (for advanced search), three different things have to happen in advance:
   * These three things can happen in any order
   * 1. The recent searches have to be retrieved (async)
   * 2. The view should be completely intialized so that the template form is available
   * 3. The isInAdvanceSearch input value should be set
   * After each of these events, we call updDispValuesForAdvSearch to see if all three conditions are met
   * If yes, we do a one time update to the controls, based on previous search results
   */
  updDispValuesForAdvSearch() {
    const recentSearchesAvailable =
      this.recentSearches && this.recentSearches.length;
    if (
      !this.updateExecutedForAdvSearch &&
      this.isViewInitialized &&
      recentSearchesAvailable &&
      this.isInAdvanceSearch
    ) {
      this.setDisplayValues();
      this.updateExecutedForAdvSearch = true;
    }
  }

  setDisplayValues() {
    if (this.srcClosestDeltaAirportCodeSubscribe) {
      this.srcClosestDeltaAirportCodeSubscribe.unsubscribe();
      this.srcClosestDeltaAirportCodeSubscribe = null;
    }
    if (
      this.recentSearchSelected !== undefined &&
      this.recentSearchSelected !== null
    ) {
      if (
        this.trackerDataService &&
        !this.trackerDataService.getRecentSearchesLoaded()
      ) {
        if (this.bookWidgetForm) {
          this.setRecentSearchResults(this.recentSearchSelected);
        }
      }
    } else if (
      this.savedSearches !== undefined &&
      this.savedSearches !== null
    ) {
      if (
        this.trackerDataService &&
        !this.trackerDataService.getSavedSearchesLoaded() &&
        this.savedSearches.savedTripsList.length > 0
      ) {
        this.setSavedSearchResults(this.savedSearches);
      }
    } else if (this.prefCityVal !== '') {
      this.getPrefCity(this.prefCityVal);
    } else {
      if (!this.fromClosestAirportcode) {
        this.setClosestAirport();
      }
    }
    this.setFlexAirport();
    this.setEdocValues();
  }

  setEdocValues() {
    if (
      this.isEdocApplied &&
      this.disabledByEdocData?.EdocTripTypeObj?.length > 0 &&
      this.uiTripTypes?.length
    ) {
      if (
        this.uiTripTypes.length ===
        this.disabledByEdocData.EdocTripTypeObj.length
      ) {
      } else {
        const multiCityIndex = [];
        let onlytripType = [];
        this.disabledByEdocData.EdocTripTypeObj.forEach((triptype) => {
          multiCityIndex.push(
            Object.keys(this.content.tripTypes).findIndex(
              (key) =>
                this.content.tripTypes[key].tripTypeValue === triptype.value
            )
          );
        });
        // console.log('length' + multiCityIndex.length + 'sss' + multiCityIndex[0]);
        switch (multiCityIndex.length) {
          case 1: {
            // only one triptype so key check
            const index = parseInt(multiCityIndex[0]);
            onlytripType = this.uiTripTypes.slice(index, index + 1);
            // this.uiTripTypes.splice(1, 2);
            this.uiTripTypes = onlytripType;
            if (this.tripTypeDropdown !== undefined) {
              this.tripTypeDropdown.optionsArray = [];
              this.tripTypeDropdown.reBind(onlytripType, 'tripTypeTitle');
              if (this.deviceTypes.isDesktop) {
                this.setSelectText(
                  '#selectTripType-val',
                  '#selectTripType-desc',
                  0
                );
              }
            }
            this.setTripType(onlytripType[0].tripTypeValue);
            break;
          }
          case 2: {
            // will not be multicity so no key check
            this.uiTripTypes.splice(2, 1);
            if (this.tripTypeDropdown !== undefined) {
              this.tripTypeDropdown.optionsArray = [];
              this.tripTypeDropdown.reBind(this.uiTripTypes, 'tripTypeTitle');
              if (this.deviceTypes.isDesktop) {
                this.setSelectText(
                  '#selectTripType-val',
                  '#selectTripType-desc',
                  0
                );
              }
            }
            this.setTripType(this.uiTripTypes[0].tripTypeValue);
            break;
          }
          default: {
            break;
          }
        }
      }
      if (this.disabledByEdocData?.bestFaresFor?.length > 0) {
        this.brands = this.disabledByEdocData.bestFaresFor;
        if (this._enableBasicFareFeature()) {
          this.brands = this.brands.filter((brand) => brand.brandId !== 'BE');
        }
        if (this.brands?.length > 0) {
          this.fareClass = this.brands[0].brandId;
          this.cdf.detectChanges();
        }
        if (this.faresForDirective) {
          this.faresForDirective.reBind(this.brands, 'brandTitle');
          this.cdf.detectChanges();
        }
      }
    }
    this.setPaxDropDownByEdoc();
    this.cdf.detectChanges();
  }

  setAemValues() {
    this.fromAirportLabel = this.content.fromLabel;
    this.fromCity = this.swapedFromCity = this.content.travelOrigin;
    this.toAirportLabel = this.content.toLabel;
    this.toCity = this.swapedToCity = this.content.travelDestinationLabel;

    if (this.content.passengers && this.content.passengers.length > 0) {
      this.passenger = this.content.passengers[0].passengerId;
    }
    if (this.brands && this.brands.length > 0) {
      this.fareClass = this.brands[0].brandId;
    }
  }

  setPaxDropDownByEdoc() {
    if (!this.vaPaxDropDown && this.isEdocApplied) {
      if (this.disabledByEdocData?.disablePaxDropDown) {
        this.disablePaxDropDown = true;
        if (
          this.disabledByEdocData.eDocMinPaxCount !== undefined &&
          this.disabledByEdocData.eDocMinPaxCount !== null &&
          this.disabledByEdocData.eDocMaxPaxCount !== undefined &&
          this.disabledByEdocData.eDocMaxPaxCount !== null &&
          this.content?.passengers?.length > 0
        ) {
          this.eDocPassengerArray = this.content.passengers.slice(
            this.disabledByEdocData.eDocMinPaxCount - 1,
            this.disabledByEdocData.eDocMaxPaxCount
          );
          if (
            this.disabledByEdocData.eDocPaxCount !== undefined &&
            this.disabledByEdocData.eDocPaxCount !== null
          ) {
            if (this.deviceTypes.isDesktop) {
              this.setSelectText(
                '#passengers-val',
                '#passengers-desc',
                this.disabledByEdocData.eDocPaxCount -
                  this.disabledByEdocData.eDocMinPaxCount
              );
            }
          }
        }
        if (
          this.disabledByEdocData.eDocMaxPaxCount ==
            this.disabledByEdocData.eDocMinPaxCount ||
          Number(this.passenger) > this.disabledByEdocData.eDocMaxPaxCount
        ) {
          this.passenger = this.disabledByEdocData.eDocMinPaxCount.toString();
          this.paxIndex = Number(this.passenger) - 1;
        }
      } else {
        this.disablePaxDropDown = false;
      }
    } else {
      this.disablePaxDropDown = false;
    }
  }

  setStoreValues() {
    this.storeSyncComplete =
      this.formStoreDir?.syncFromStoreComplete?.subscribe(
        () => {
          const formValue = this.formStoreDir.formValueRef;
          if (formValue && Object.getOwnPropertyNames(formValue).length > 0) {
            Object.getOwnPropertyNames(formValue).forEach((controlName) => {
              this.bookWidgetForm
                .get(controlName)
                ?.patchValue(formValue[controlName]);
            });
            this.fromAirportcode = formValue['airports'].fromAirportcode;
            this.fromCity = formValue['airports'].fromCity;
            this.toAirportcode = formValue['airports'].toAirportcode;
            this.toCity = formValue['airports'].toCity;
            this.selectTripType = formValue['selectTripType']
              ? formValue['selectTripType']
              : this.selectTripType;
            this.passenger = formValue['passenger']
              ? formValue['passenger']
              : this.passenger;
            this.schedulePrice = formValue['schedulePrice']
              ? formValue['schedulePrice']
              : this.schedulePrice;
            this.fareClass = formValue['faresFor']
              ? formValue['faresFor']
              : this.fareClass;
          }
          this.triptypeIndex = this.getTripTypeIndex(this.selectTripType);
          this.paxIndex = this.passenger
            ? Number(this.passenger) - 1
            : this.paxIndex;
          if (this.brands) {
            const selectedIndex = Object.keys(this.brands).findIndex(
              (key) => this.brands[key].brandId === this.fareClass
            );
            this.fareIndex =
              selectedIndex >= 0 ? selectedIndex : this.fareIndex;
          }
          this.setTripType(this.selectTripType);
          if (this.selectTripType == 'MULTICITY')
            this.transformMulticityData(formValue);
          if (this.deviceTypes.isDesktop) this.bindDropdowns();
          if (this.schedulePrice === 'miles') {
            this.setAwardTravel(this.schedulePrice);
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  transformMulticityData(formValue): void {
    const flightsData = formValue['flights'];
    formValue['airports'] = flightsData.map(
      ({ airports, connectionAirport }) => ({
        ...airports,
        connectionAirport
      })
    );
    formValue['dates'] = flightsData.map(({ departureDate }) => ({
      departureDate,
      returnDate: ''
    }));
    this.recentlySearchedMulticityData = formValue;
  }

  bindDropdowns(): void {
    this.setSelectText(
      '#selectTripType-val',
      '#selectTripType-desc',
      this.triptypeIndex
    );
    this.setSelectText('#passengers-val', '#passengers-desc', this.paxIndex);
    this.setSelectText('#faresFor-val', '#faresFor-desc', this.fareIndex);
  }

  getSelectedTripType() {
    if (
      this.selectTripType &&
      this.selectTripType.trim() !== '' &&
      this.content &&
      this.content.tripTypes
    ) {
      const selectedIndex = this.content.tripTypes.findIndex(
        (value) => value.tripTypeValue === this.selectTripType
      );
      if (this.nextgenPage) {
        return (this.tripTypeDropIndex =
          selectedIndex > -1 ? selectedIndex : 0);
      } else {
        return selectedIndex > -1 ? selectedIndex : 0;
      }
    }
    return this.nextgenPage ? this.tripTypeDropIndex : 0;
  }

  getSelectedPassengerIndex() {
    if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
      this.disablePassengerDropdown();
    } else {
      if (
        this.passenger &&
        this.passenger.trim() !== '' &&
        this.content &&
        this.content.passengers
      ) {
        if (this.isEdocApplied) {
          if (this.eDocPassengerArray.length > 0) {
            const selectedIndex = this.eDocPassengerArray.findIndex(
              (value) => value.passengerId === this.passenger
            );
            this.enablePassengerDropDown();
            if (this.nextgenPage) {
              return (this.passengerDropIndex =
                selectedIndex > -1 ? selectedIndex : 0);
            } else {
              return selectedIndex > -1 ? selectedIndex : 0;
            }
          }
        } else {
          const selectedIndex = this.content.passengers.findIndex(
            (value) => value.passengerId === this.passenger
          );
          this.enablePassengerDropDown();
          if (this.nextgenPage) {
            return (this.passengerDropIndex =
              selectedIndex > -1 ? selectedIndex : 0);
          } else {
            return selectedIndex > -1 ? selectedIndex : 0;
          }
        }
      }
    }
    return this.nextgenPage ? this.passengerDropIndex : 0;
  }

  disablePassengerDropdown() {
    this.passenger = '1';
    this.paxIndex = 0;
    this.bookWidgetForm.get('passenger').disable();
    //   if (
    //     document.body.querySelector('#passengers-val') != null &&
    //     document.body.querySelector('#passengers-val') !== undefined
    //   ) {
    //     document.body
    //       .querySelector('#passengers-val')
    //       .previousElementSibling.classList.add('d-none');
    //   }
  }

  enablePassengerDropDown() {
    this.bookWidgetForm.get('passenger').enable();
    // if (
    //   document.body.querySelector('#passengers-val') != null &&
    //   document.body.querySelector('#passengers-val') !== undefined
    // ) {
    //   document.body
    //     .querySelector('#passengers-val')
    //     .previousElementSibling.classList.remove('d-none');
    // }
  }

  setTripType(tripType: any, isSelectTripType = false) {
    this.selectTripType = tripType;
    if (this.oldTripType !== this.selectTripType) {
      this.flightHotelMobileSwap = false;
      this.bookWidgetForm.controls['flightHotelDeals'].setValue(
        this.flightHotelMobileSwap
      );
    } else {
      this.flightHotelMobileSwap =
        this.bookWidgetForm.get('flightHotelDeals').value;
    }

    if (this.bookWidgetForm && this.errorHandler) {
      this.errorHandler.resetTheForm();
    }

    this.removeAllFormControl();

    this.addFormControlFor(tripType);
    this.isSubmitted = false;
    this.setFlexAirport();

    if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      tripType === 'MULTICITY'
    ) {
      this.restrictmpmTravel = false;
      this.restrictMiles = false;
      this.restrictCash = false;
      this.restrictFlightHotel = true;
      this.restrictNonJvPartner = true;
      this.flightHotelMobileSwap = false;
    }

    if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      this.oldTripType === 'MULTICITY'
    ) {
      this.resetODPairRestrictions();
    }

    if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      this.oldTripType !== 'MULTICITY' &&
      tripType === 'ONE_WAY'
    ) {
      this.restrictFlightHotel = true;
    } else if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      this.oldTripType !== 'MULTICITY' &&
      tripType === 'ROUND_TRIP'
    ) {
      this.setFlightHotelRestriction();
    }

    this.oldTripType = tripType;

    if (this.config.onBrowser) {
      const mobileWidgetScrollableContainer = document.getElementsByClassName(
        'mobile-widget-scrollable-container'
      )[0];

      if (
        mobileWidgetScrollableContainer !== undefined &&
        mobileWidgetScrollableContainer !== null
      ) {
        if (tripType === 'MULTICITY' && !this.isAdvSearchExpanded) {
          mobileWidgetScrollableContainer.classList.add(
            'mobile-widget-multicity-container'
          );
        } else {
          mobileWidgetScrollableContainer.classList.remove(
            'mobile-widget-multicity-container'
          );
        }
      }
    }

    if (this.selectTripType === 'MULTICITY') {
      this.isFlexDate = false;
      this.enableCloseButton =
        this.widgetTopPosition === 'sticky' ? false : true; // rsb-10556-Flex Search returning with an Error(Observed in Prod & Si, Advanced
    } else {
      this.enableCloseButton = false;
    }
  }

  removeAllFormControl() {
    this.bookWidgetForm
      .get('airports')
      .get('fromAirportcode')
      .clearValidators();
    this.bookWidgetForm.get('airports').get('toAirportcode').clearValidators();
    this.bookWidgetForm.get('airports').clearValidators();
    this.bookWidgetForm.get('dates').clearValidators();
  }

  addFormControlFor(val) {
    /** remove the duplicate form validators when doing revamp*/
    if (val === 'MULTICITY') {
    } else if (val === 'ROUND_TRIP') {
      this.bookWidgetForm
        .get('airports')
        .get('fromAirportcode')
        .setValidators([validatonAirport, validateAirportCode]);
      this.bookWidgetForm
        .get('airports')
        .get('toAirportcode')
        .setValidators([validatonAirport, validateAirportCode]);
      this.bookWidgetForm
        .get('airports')
        .setValidators(
          validateFromAndToAirportsForBook('fromAirportcode', 'toAirportcode')
        );
      this.bookWidgetForm
        .get('dates')
        .setValidators(departureAndReturnDate('departureDate', 'returnDate'));
      this.bookWidgetForm
        .get('airports')
        .get('fromAirportcode')
        .updateValueAndValidity();
      this.bookWidgetForm
        .get('airports')
        .get('toAirportcode')
        .updateValueAndValidity();
      this.bookWidgetForm.get('dates').updateValueAndValidity();
      this.bookWidgetForm.get('airports').updateValueAndValidity();
    } else if (val === 'ONE_WAY') {
      this.bookWidgetForm
        .get('airports')
        .get('fromAirportcode')
        .setValidators([validatonAirport, validateAirportCode]);
      this.bookWidgetForm
        .get('airports')
        .get('toAirportcode')
        .setValidators([validatonAirport, validateAirportCode]);
      this.bookWidgetForm
        .get('airports')
        .setValidators(
          validateFromAndToAirportsForBook('fromAirportcode', 'toAirportcode')
        );
      this.bookWidgetForm
        .get('dates')
        .setValidators(onlyDepartureDate('departureDate'));
      this.bookWidgetForm
        .get('airports')
        .get('fromAirportcode')
        .updateValueAndValidity();
      this.bookWidgetForm
        .get('airports')
        .get('toAirportcode')
        .updateValueAndValidity();
      this.bookWidgetForm.get('airports').updateValueAndValidity();
      this.bookWidgetForm.get('dates').updateValueAndValidity();
    }
  }

  swapCity() {
    const from = this.fromAirportcode;
    const to = this.toAirportcode;
    const fromCountryCode = this.fromCountryCode;
    const toCountryCode = this.toCountryCode;
    const fromCity = this.fromCity;
    const toCity = this.toCity;

    this.fromAirportcode = to;
    this.toAirportcode = from;
    this.fromCountryCode = toCountryCode;
    this.toCountryCode = fromCountryCode;
    this.toCity = fromCity;
    this.fromCity = toCity;
    if (this.fromAirportcode === '') {
      this.fromCity = this.swapedFromCity;
    }
    if (this.toAirportcode === '') {
      this.toCity = this.swapedToCity;
    }
    this.getOdPairAttributes();
    this.setSwapLinkFocus();
    this.cdf.detectChanges();
  }

  setSwapLinkFocus() {
    const span = this.el.nativeElement.querySelector('.swap-container span');
    if (span === null) {
      this.showSwapSpan = true;
    } else if (span !== null && span !== undefined) {
      this.reverseBtnAction();
      this.showSwapSpan = true;
    }
  }

  reverseBtnAction() {
    this.showSwapSpan = false;
    this.cdf.detectChanges();
  }

  getOdPairAttributes() {
    if (
      this.odPairRestriction &&
      this.odPairRestriction.toLowerCase() === 'true' &&
      this.toAirportcode !== undefined &&
      this.toAirportcode !== '' &&
      this.fromAirportcode !== undefined &&
      this.fromAirportcode !== ''
    ) {
      this.searchService.getCitiesAttributes(
        this.toAirportcode,
        this.fromAirportcode,
        this.odPairRestriction
      );
    }
    this.bookWidgetForm.get('flightHotelDeals').setValue(false);
    this.setDisclaimer();
  }

  setODPairAttributes() {
    this.searchService.airportUpdate
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((value) => {
        if (value && value.length > 0) {
          if (
            this.selectTripType !== undefined &&
            this.selectTripType !== 'MULTICITY'
          ) {
            this.setODPairRestrictions(value[0]);
            this.tempDestinationCity = value[0].city;
          }
        } else {
        }
      });
  }

  setODPairRestrictions(airport) {
    this.fromAirportcode = this.bookWidgetForm
      .get('airports')
      .get('fromAirportcode').value;
    this.fromCity = this.bookWidgetForm.get('airports').get('fromCity').value;
    if (
      this.odPairRestriction !== undefined &&
      this.odPairRestriction.toLowerCase() === 'true'
    ) {
      this.bookWidgetForm.get('flightHotelDeals').setValue(false);
      this.setDisclaimer();
      if (this.toAirportcode !== '') {
        if (airport.restrictMPM === 'TRUE') {
          this.restrictmpmTravel = true;
        } else {
          this.restrictmpmTravel = false;
        }
        if (airport.restrictMiles === 'TRUE') {
          this.restrictMiles = true;
        } else {
          this.restrictMiles = false;
        }
        if (airport.restrictCash === 'TRUE') {
          this.restrictCash = true;
        } else {
          this.restrictCash = false;
        }
        if (
          airport.restrictFlightHotel === undefined ||
          airport.restrictFlightHotel === '' ||
          airport.restrictFlightHotel === 'TRUE'
        ) {
          this.restrictFlightHotel = true;
        } else {
          this.restrictFlightHotel = false;
        }
        this.restrictFlightHotelOrig = this.restrictFlightHotel;
        if (!this.restrictFlightHotel) {
          this.setFlightHotelRestriction();
        }
        const multiCityIndexTemp = Object.keys(this.uiTripTypes).findIndex(
          (key) => this.uiTripTypes[key].tripTypeValue === 'MULTICITY'
        );
        if (
          airport.restrictNonJvPartner !== undefined &&
          airport.restrictNonJvPartner.toUpperCase() === 'FALSE'
        ) {
          this.restrictNonJvPartner = false;
          if (multiCityIndexTemp > -1) {
            this.uiTripTypes.splice(multiCityIndexTemp, 1);
            if (this.tripTypeDropdown !== undefined) {
              this.tripTypeDropdown.optionsArray = [];
              this.tripTypeDropdown.reBind(this.uiTripTypes, 'tripTypeTitle');
              this.setSelectText(
                '#selectTripType-val',
                '#selectTripType-desc',
                0
              );
            }
          }
        } else {
          this.restrictNonJvPartner = true;
          if (multiCityIndexTemp === -1) {
            this.uiTripTypes.splice(this.multiCityIndex, 2, this.multiCity);
            if (this.tripTypeDropdown !== undefined) {
              this.tripTypeDropdown.optionsArray = [];
              this.tripTypeDropdown.reBind(this.uiTripTypes, 'tripTypeTitle');
              this.cdf.detectChanges();
              this.setSelectText(
                '#selectTripType-val',
                '#selectTripType-desc',
                0
              );
            }
          }
        }
        if (
          airport.flightHotelDest !== '' ||
          airport.flightHotelDest !== undefined
        ) {
          this.flightHotelDest = airport.flightHotelDest;
        } else {
          this.flightHotelDest = '';
        }
      }
      this.cdf.detectChanges();
    }
    this.bookWidgetForm.controls['flightHotelDeals'].setValue(
      this.flightHotelMobileSwap
    );
    this.isChecked('', this.flightHotelMobileSwap);
    this.setFaresFor();
    this.setToolTip();
  }

  setFlightHotelRestriction() {
    const departDate = this.bookWidgetForm.get('dates.departureDate').value;
    const returnDate = new Date(
      this.bookWidgetForm.get('dates.returnDate').value
    );
    this.bookWidgetForm.get('flightHotelDeals').setValue(false);
    this.setDisclaimer();
    if (
      this.selectTripType === 'ROUND_TRIP' &&
      departDate !== undefined &&
      departDate !== null &&
      returnDate !== undefined &&
      returnDate != null
    ) {
      const duration = parseInt(this.getDuration());
      if (
        this.flightplushotelduration !== undefined &&
        this.flightplushotelduration !== null &&
        duration > 0 &&
        duration < parseInt(this.flightplushotelduration)
      ) {
        this.restrictFlightHotel = this.restrictFlightHotelOrig;
      } else {
        this.restrictFlightHotel = true;
      }
    } else {
      this.restrictFlightHotel = true;
    }
    this.bookWidgetForm.controls['flightHotelDeals'].setValue(
      this.flightHotelMobileSwap
    );
  }

  setFaresFor() {
    const selectedValue =
      this.bookWidgetForm.get('schedulePrice').value.value === undefined
        ? this.bookWidgetForm.get('schedulePrice').value
        : this.bookWidgetForm.get('schedulePrice').value.value;
    const priceSelected =
      selectedValue === 'price' || selectedValue === 'money' ? true : false;
    const milesSelected = selectedValue === 'miles' ? true : false;
    const milesPlusMoneySelected =
      selectedValue === 'milesplusmoney' ? true : false;

    if (priceSelected && this.restrictCash && !this.restrictMiles) {
      this.schedulePrice = 'miles';
      this.bookWidgetForm.get('schedulePrice').setValue('miles');
      this.setAwardTravel('miles');
    } else if (
      priceSelected &&
      this.restrictCash &&
      this.restrictMiles &&
      !this.restrictmpmTravel
    ) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('milesplusmoney');
      this.setAwardTravel('price');
    } else if (
      priceSelected &&
      this.restrictCash &&
      this.restrictMiles &&
      this.restrictmpmTravel
    ) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('price');
      this.setAwardTravel('price');
    } else if (milesSelected && this.restrictMiles && !this.restrictCash) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('price');
      this.setAwardTravel('price');
    } else if (
      milesSelected &&
      this.restrictMiles &&
      this.restrictCash &&
      !this.restrictmpmTravel
    ) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('milesplusmoney');
      this.setAwardTravel('price');
    } else if (
      milesSelected &&
      this.restrictMiles &&
      this.restrictCash &&
      this.restrictmpmTravel
    ) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('price');
      this.setAwardTravel('price');
    } else if (
      milesPlusMoneySelected &&
      this.restrictmpmTravel &&
      !this.restrictCash
    ) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('price');
      this.setAwardTravel('price');
    } else if (
      milesPlusMoneySelected &&
      this.restrictmpmTravel &&
      this.restrictCash &&
      !this.restrictMiles
    ) {
      this.schedulePrice = 'miles';
      this.bookWidgetForm.get('schedulePrice').setValue('miles');
      this.setAwardTravel('miles');
    } else if (
      milesPlusMoneySelected &&
      this.restrictMiles &&
      this.restrictCash &&
      this.restrictmpmTravel
    ) {
      this.schedulePrice = 'price';
      this.bookWidgetForm.get('schedulePrice').setValue('price');
      this.setAwardTravel('price');
    }
  }

  setToolTip() {
    if (this.restrictmpmTravel && !this.restrictMiles && !this.restrictCash) {
      this.tooltipValue = 'miles-plus-money';
    } else if (
      this.restrictmpmTravel &&
      this.restrictMiles &&
      !this.restrictCash
    ) {
      this.tooltipValue = 'miles-miles-plus-money';
    } else if (
      this.restrictmpmTravel &&
      !this.restrictMiles &&
      this.restrictCash
    ) {
      this.tooltipValue = 'card-miles-plus-money';
    } else if (
      !this.restrictmpmTravel &&
      this.restrictMiles &&
      this.restrictCash
    ) {
      this.tooltipValue = 'card-miles';
    } else if (
      !this.restrictmpmTravel &&
      !this.restrictMiles &&
      this.restrictCash
    ) {
      this.tooltipValue = 'pay-with-card';
    } else if (
      this.restrictmpmTravel &&
      this.restrictMiles &&
      this.restrictCash
    ) {
      this.tooltipValue = 'miles-miles-plus-money';
    } else {
      this.tooltipValue = 'show-price-in';
    }
  }

  resetODPairRestrictions() {
    if (
      this.odPairRestriction !== undefined &&
      this.odPairRestriction.toLowerCase() === 'true'
    ) {
      this.restrictmpmTravel = false;
      this.restrictMiles = false;
      this.restrictCash = false;
      this.restrictFlightHotel = true;
      this.restrictNonJvPartner = true;
      this.toAirportcode = '';
      this.disableMulityCity = false;
      this.toCity = '';
      this.bookWidgetForm.get('flightHotelDeals').setValue(false);
      this.setDisclaimer();
      const multiCityIndexTemp = Object.keys(this.uiTripTypes).findIndex(
        (key) => this.uiTripTypes[key].tripTypeValue === 'MULTICITY'
      );
      if (multiCityIndexTemp === -1) {
        this.uiTripTypes.splice(this.multiCityIndex, 2, this.multiCity);
        this.tripTypeDropdown.reBind(this.uiTripTypes, 'tripTypeTitle');
        this.cdf.detectChanges();
      }
      this.cdf.detectChanges();
    }
  }

  setMultiCityRestriction(restrictions) {
    this.restrictmpmTravel = restrictions[0];
    this.restrictMiles = restrictions[1];
    this.restrictCash = restrictions[2];
    this.restrictNonJvPartner = true;
    this.restrictFlightHotel = true;
    this.setFaresFor();
    this.setToolTip();
    this.cdf.detectChanges();
  }

  tripTypeChnagedTriggeredHandler(searchData: SearchSegmentData) {
    this.fromAirportcode = searchData.fromAirportCode;
    this.fromCity = searchData.fromCity;
    this.toAirportcode = searchData.toAirportcode;
    this.toCity = searchData.toCity;
    this.fromCountryCode = searchData.fromCountryCode;
    this.toCountryCode = searchData.toCountryCode;
    this.bookWidgetForm
      .get('dates.departureDate')
      .setValue(searchData.departDate);
    this.forHiddendepartureDate = searchData.departDate
      ? this.formateDate(searchData.departDate)
      : '';
    this.bookWidgetForm.get('dates.returnDate').setValue(searchData.returnDate);
    this.cdf.detectChanges();
  }

  setPassenger(passengers) {
    let totalCount = 0;
    let adtGbeCount = 0;
    const infantCount = 0;
    const adtCount = 0;
    this.detailPassenger = [];
    this.adtCount = 0;
    this.gbeCount = 0;
    this.cnnCount = 0;
    this.infCount = 0;
    for (let index = 0; index < passengers.length; index++) {
      this.adtCount =
        passengers[index].passengertypeId === 'ADT'
          ? parseInt(passengers[index].passengerCount)
          : this.adtCount;
      this.gbeCount =
        passengers[index].passengertypeId === 'GBE'
          ? parseInt(passengers[index].passengerCount)
          : this.gbeCount;
      this.cnnCount =
        passengers[index].passengertypeId === 'CNN'
          ? parseInt(passengers[index].passengerCount)
          : this.cnnCount;
      this.infCount =
        passengers[index].passengertypeId === 'INF'
          ? parseInt(passengers[index].passengerCount)
          : this.infCount;
      totalCount = totalCount + parseInt(passengers[index].passengerCount);
    }
    this.passenger = totalCount + '';
    adtGbeCount = this.adtCount + this.gbeCount;
    this.bookWidgetForm.controls['adtGbeCount'].setValue(adtGbeCount);
    this.bookWidgetForm.controls['adtCount'].setValue(this.adtCount);
    this.bookWidgetForm.controls['infantCount'].setValue(this.infCount);
    this.bookWidgetForm.controls['cnnCount'].setValue(this.cnnCount);
    this.bookWidgetForm.controls['gbeCount'].setValue(this.gbeCount);
    this.bookWidgetForm
      .get('passenger')
      .setValidators([
        adtPaxCount('adtCount'),
        totalPaxCount,
        infantPaxCount('adtGbeCount', 'infantCount')
      ]);
    this.bookWidgetForm.controls['passenger'].setValue(this.passenger);
    this.childPassenger = true;
  }

  customChangeEventHandlerForTripType(val, isSelectTripType = false) {
    this.setTripType(val, isSelectTripType);
  }

  customChangeEventHandlerForPax(val) {
    this.passenger = val;
  }

  customChangeEventHandlerForFaresFor(val) {
    this.fareClass = val;
  }

  toggleAdvancedSearch(inMobile: boolean, el: any) {
    this.isAdvSearchExpanded = !this.isAdvSearchExpanded;
    this.cdf.detectChanges();
    this.advSearchExpanded.emit(this.isAdvSearchExpanded);
    if (this.isAdvSearchExpanded && !this.awardTravel) {
      this.bookWidgetForm
        .get('meetingEventCode')
        .setValidators([
          Validators.maxLength(5),
          Validators.pattern('^[a-zA-Z0-9]*$')
        ]);
    } else {
      this.bookWidgetForm.get('meetingEventCode').clearValidators();
    }
    this.bookWidgetForm.get('meetingEventCode').updateValueAndValidity();
    if (inMobile && this.isAdvSearchExpanded) {
      const modalScrollHeight = document.getElementsByClassName(
        'mobile-widget-scrollable-container'
      )[0].scrollHeight;
      const modalOffsetHeight = (<HTMLElement>(
        document.getElementsByClassName('mobile-widget-scrollable-container')[0]
      )).offsetHeight;
      const actionBarHeight = (<HTMLElement>(
        document.getElementsByClassName('action-bar-mobile-widget')[0]
      )).offsetHeight;
      document.getElementsByClassName(
        'mobile-widget-scrollable-container'
      )[0].scrollTop =
        modalScrollHeight - modalOffsetHeight - actionBarHeight + 40;
      const mobileWidgetScrollableContainer = document.getElementsByClassName(
        'mobile-widget-scrollable-container'
      )[0];
      if (
        mobileWidgetScrollableContainer !== undefined &&
        mobileWidgetScrollableContainer !== null
      ) {
        mobileWidgetScrollableContainer.classList.remove(
          'mobile-widget-multicity-container'
        );
      }
    } else if (
      inMobile &&
      !this.isAdvSearchExpanded &&
      this.selectTripType === 'MULTICITY'
    ) {
      const mobileWidgetScrollableContainer = document.getElementsByClassName(
        'mobile-widget-scrollable-container'
      )[0];
      if (
        mobileWidgetScrollableContainer !== undefined &&
        mobileWidgetScrollableContainer !== null
      ) {
        mobileWidgetScrollableContainer.classList.add(
          'mobile-widget-multicity-container'
        );
      }
    }
  }

  toggleExpander() {
    this.isWidgetExpanded = !this.isWidgetExpanded;
    this.isAdvSearchExpanded = false;
    this.advSearchExpanded.emit(this.isAdvSearchExpanded);
    if (this.bookWidgetForm) {
      this.bookWidgetForm.get('meetingEventCode').clearValidators();
      this.bookWidgetForm.get('meetingEventCode').updateValueAndValidity();
    }
    if (!this.isWidgetExpanded) {
      window.scrollTo(0, 0);
    }
  }

  airportSelected(airportSelected) {
    this.fromAirportcode = airportSelected.airportCode;
    this.fromCity = airportSelected.airportCity;
  }

  meetingCodeExists(recentSearchSelected) {
    if (!recentSearchSelected) {
      return false;
    }
    const meetingEventCode = recentSearchSelected?.meetingEventCode;
    const invalidValues = ['null', 'undefined'];
    return (
      meetingEventCode?.length &&
      invalidValues.indexOf(meetingEventCode?.toLowerCase()) < 0
    );
  }

  setRecentSearchResults(recentSearchSelected) {
    if (!this.searchPrefillFlag && recentSearchSelected) {
      if (this.bookWidgetForm.get('basicFaresField')) {
        let value = true;
        if (
          this._enableBasicFareFeature() &&
          recentSearchSelected.includeBasicFaresUnchecked
        ) {
          value = false;
        }

        this.bookWidgetForm.get('basicFaresField').setValue(value);
      }

      if (recentSearchSelected.selectTripType === 'MULTICITY') {
        this.recentlySearchedMulticityData = recentSearchSelected;
        recentSearchSelected.airports = recentSearchSelected.airports;
      } else {
        recentSearchSelected.airports = new Airports(
          recentSearchSelected.airports
        );
      }

      this.fromAirportcode = recentSearchSelected.airports.fromAirportcode;
      this.fromCity = recentSearchSelected.airports.fromCity;
      this.toAirportcode = recentSearchSelected.airports.toAirportcode;
      this.toCity = recentSearchSelected.airports.toCity;
      this.fromCountryCode =
        recentSearchSelected.airports?.fromCountryCode ||
        recentSearchSelected.airports?.fromCountryCd;
      this.toCountryCode =
        recentSearchSelected.airports?.toCountryCode ||
        recentSearchSelected.airports?.toCountryCd;
      recentSearchSelected.passenger =
        recentSearchSelected.passenger !== 'null' &&
        recentSearchSelected.passenger
          ? recentSearchSelected.passenger
          : this.passenger;
      this.passenger = recentSearchSelected.passenger;
      const dpdate = recentSearchSelected.dates.departureDate,
        tdyDt = new Date();
      let dtDepartureDate;
      if (dpdate) {
        dtDepartureDate = new Date(dpdate);
        if (dtDepartureDate < tdyDt) {
          dtDepartureDate = tdyDt;
        }
        const formattedDepartureDate = this.getDateString(dtDepartureDate);
        this.bookWidgetForm
          .get('dates.departureDate')
          .setValue(formattedDepartureDate);
      } else {
        this.bookWidgetForm
          .get('dates.departureDate')
          .setValue(recentSearchSelected.dates.departureDate);
      }
      if (
        !this.isEdocApplied &&
        this.disabledByEdocData?.EdocTripTypeObj?.length !== 1
      ) {
        this.setTripType(recentSearchSelected.selectTripType);
      }
      if (this.selectTripType === 'ROUND_TRIP') {
        this.bookWidgetForm
          .get('dates.returnDate')
          .setValue(recentSearchSelected.dates.returnDate);
      }
      if (this.bookWidgetForm.get('chkFlexDate')) {
        this.bookWidgetForm
          .get('chkFlexDate')
          .setValue(
            recentSearchSelected.chkFlexDate
              ? recentSearchSelected.chkFlexDate
              : false
          );
      }
      if (!this.isEdocApplied) {
        if (this.meetingCodeExists(recentSearchSelected)) {
          this.bookWidgetForm
            .get('meetingEventCode')
            .setValue(recentSearchSelected.meetingEventCode);
        }
        this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(
          this.refundableCheckboxDdcfb() ||
            recentSearchSelected.refundableFlightsOnly
            ? true
            : false
        );
        this.bookWidgetForm.controls['nearbyAirports'].setValue(
          recentSearchSelected.nearbyAirports ? true : false
        );
        const fareFor = this.getFareForValue(recentSearchSelected);
        if (this.mpmTravel) {
          this.bookWidgetForm.get('schedulePrice').setValue(fareFor);
        } else {
          if (this.profileSelectorEnableMilesFlag) {
            this.bookWidgetForm
              .get('schedulePrice')
              .setValue(
                recentSearchSelected.awardTravel && !this.restrictMiles
                  ? 'miles'
                  : 'price'
              );
          } else {
            this.bookWidgetForm
              .get('schedulePrice')
              .setValue(
                recentSearchSelected.awardTravel && !this.isBusiness
                  ? 'miles'
                  : 'price'
              );
          }
          this.schedulePrice = fareFor;
        }
        if (this.isBusiness && !this.profileSelectorEnableMilesFlag) {
          this.awardTravel = false;
        } else {
          this.awardTravel = recentSearchSelected.awardTravel;
        }
        if (this.bookWidgetForm.get('dates.chkFlexDate')) {
          this.bookWidgetForm
            .get('dates.chkFlexDate')
            .setValue(
              recentSearchSelected.dates.chkFlexDate
                ? recentSearchSelected.chkFlexDate
                : false
            );
        }
        if (this.awardTravel === true && !this.restrictMiles) {
          this.setAwardTravel('miles');
          this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(false);
        } else {
          this.setAwardTravel('price');
        }
        this.triptypeIndex = this.getTripTypeIndex(
          recentSearchSelected.selectTripType
        );

        if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
          this.paxIndex = 0;
          this.passenger = '1';
        } else {
          this.paxIndex = recentSearchSelected.passenger - 1;
          this.passenger = recentSearchSelected.passenger;
        }
        if (this.content?.brands.length > 0 && recentSearchSelected.faresFor) {
          for (let index = 0; index < this.content.brands.length; index++) {
            if (
              this.content.brands[index].brandId.toUpperCase() ===
              recentSearchSelected.faresFor.toUpperCase()
            ) {
              this.fareClass = this.content.brands[index].brandId;
              if (this.config.get('APP_BE_BRAND') === '') {
                this.fareIndex = index;
              } else {
                this.fareIndex = this.awardTravel ? index - 1 : index;
              }
            }
          }
        }
        if (this.deviceTypes.isDesktop) {
          this.setSelectText(
            '#selectTripType-val',
            '#selectTripType-desc',
            this.triptypeIndex
          );
          this.setSelectText(
            '#passengers-val',
            '#passengers-desc',
            this.paxIndex
          );
          this.setSelectText('#faresFor-val', '#faresFor-desc', this.fareIndex);
        }
        this.forHiddendepartureDate = this.formateDate(
          recentSearchSelected.dates.departureDate
        );
        this.forHiddenreturnDate = this.formateDate(
          recentSearchSelected.dates.returnDate
        );
        this.trackerDataService.setRecentSearchesLoaded(true);
      }
      this.cdf.detectChanges();
      this.getOdPairAttributes();
      if (this.bestFareDropdown) {
        this.bestFareDropdown.reBind(this.brands, 'brandTitle', this.fareIndex);
      }
    }
  }

  setSavedSearchResults(savedSearchSelected) {
    this.forHiddendepartureDate = this.formateDate(
      this.bookWidgetForm.get('dates.departureDate').value
    );
    this.forHiddenreturnDate = this.formateDate(
      this.bookWidgetForm.get('dates.returnDate').value
    );
    if (!this.searchPrefillFlag) {
      this.fromAirportcode =
        savedSearchSelected.savedTripsList[0].origDestInfos[0].originCityCd;
      this.fromCity = '';
      this.fromCountryCode = '';
      this.toCountryCode = '';
      this.toAirportcode =
        savedSearchSelected.savedTripsList[0].origDestInfos[0].destinationCityCd;
      this.toCity = '';
      if (!this.isEdocApplied) {
        if (savedSearchSelected.savedTripsList[0].tripType !== null) {
          this.setTripType(savedSearchSelected.savedTripsList[0].tripType);
        }
        this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(
          this.refundableCheckboxDdcfb() ||
            savedSearchSelected.savedTripsList[0].isRefundable
            ? true
            : false
        );
        this.awardTravel =
          savedSearchSelected.savedTripsList[0].isRedeemMiles ||
          this.shopWithMilesClicked;
        if (
          savedSearchSelected.savedTripsList[0].isRedeemMiles === true ||
          this.shopWithMilesClicked
        ) {
          this.setAwardTravel('miles');
        } else {
          this.setAwardTravel('price');
        }
        this.bookWidgetForm
          .get('schedulePrice')
          .setValue(
            savedSearchSelected.savedTripsList[0].isRedeemMiles ||
              this.shopWithMilesClicked
              ? 'miles'
              : 'price'
          );
        if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
          this.paxIndex = 0;
          this.passenger = '1';
        } else {
          this.paxIndex = (
            savedSearchSelected.savedTripsList[0].numberOfPassengers - 1
          ).toString();
          this.passenger =
            savedSearchSelected.savedTripsList[0].numberOfPassengers.toString();
        }
        if (this.vaPaxDropDown) {
          this.childPassengerComponent.setSavedSearchPassengers(this.passenger);
        }
        if (
          this.content &&
          this.content.brands &&
          this.content.brands.length > 0
        ) {
          if (
            savedSearchSelected.savedTripsList[0].cabin !== undefined &&
            savedSearchSelected.savedTripsList[0].cabin !== null
          ) {
            for (let index = 0; index < this.content.brands.length; index++) {
              if (savedSearchSelected.savedTripsList[0].cabin) {
                if (
                  this.content.brands[index].brandId.toUpperCase() ===
                  savedSearchSelected.savedTripsList[0].cabin.toUpperCase()
                ) {
                  this.fareClass = this.content.brands[index].brandId;
                  if (this.config.get('APP_BE_BRAND') === '') {
                    this.fareIndex = index;
                  } else {
                    this.fareIndex = this.awardTravel ? index - 1 : index;
                  }
                }
              }
            }
          } else {
            this.fareIndex = 0;
          }
        }
        if (this.deviceTypes.isDesktop) {
          this.setSelectText(
            '#selectTripType-val',
            '#selectTripType-desc',
            this.triptypeIndex
          );
          this.setSelectText(
            '#passengers-val',
            '#passengers-desc',
            this.paxIndex
          );
          this.setSelectText('#faresFor-val', '#faresFor-desc', this.fareIndex);
        }
        this.trackerDataService.setSavedSearchesLoaded(true);
      }
      this.cdf.detectChanges();
      this.getOdPairAttributes();
    }
  }

  setSelectText(val, desc, index) {
    if (
      this.el.nativeElement.querySelector(val) !== undefined &&
      this.el.nativeElement.querySelector(desc) !== null &&
      this.el.nativeElement.querySelector(desc).children[index] !== undefined
    ) {
      this.el.nativeElement.querySelector(val).innerHTML =
        this.el.nativeElement.querySelector(desc).children[index].innerHTML;
    }
  }

  getSavedTripsFeatureFlag() {
    try {
      this.userData.getAuthConfigContent().subscribe((response) => {
        if (response && response['GET_SAVED_TRIPS_AWS_API_FLAG'] === true) {
          this.getSavedTripsFlag = response['GET_SAVED_TRIPS_AWS_API_FLAG'];
        } else {
          this.getSavedTripsFlag = false;
        }
      });
    } catch (error) {
      this.loggingService.log(
        'Error Reading GET_SAVED_TRIPS_AWS_API_FLAG Feature Flags'
      );
    }
  }

  getSavedResponse(custId): Observable<any | GetSavedTrips> {
    if (this.getSavedTripsFlag) {
      return this.getSaveTrips.getSavedTrips();
    } else {
      return this.trackerDataService.getSavedSearches(custId);
    }
  }

  setSavedSearchesAirport(custId) {
    if (custId !== undefined && custId !== '') {
      this.trackerServiceSavedSearchesSubscribe = this.getSavedResponse(custId)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            if (res !== null && res !== undefined && res !== '') {
              if (
                res.customer !== undefined &&
                res.customer !== null &&
                res.customer.savedTripList !== undefined &&
                res.customer.savedTripList !== null
              ) {
                if (res.customer.savedTripList.length > 0) {
                  this.savedSearchesAvailable = true;
                  this.savedSearches = new SavedsearchesModel(res);
                  if (this.bookWidgetForm !== undefined) {
                    this.setDisplayValues();
                  }
                }
              } else {
                if (this.bookWidgetForm !== undefined) {
                  this.setDisplayValues();
                }
              }
            } else {
              if (this.bookWidgetForm !== undefined) {
                this.setDisplayValues();
              }
            }
          },
          (err) => {
            this.savedSearch = false;
            if (this.bookWidgetForm !== undefined) {
              this.setDisplayValues();
            }
          }
        );
    } else {
      if (this.bookWidgetForm !== undefined) {
        this.setDisplayValues();
      }
    }

    this.issetSavedSearchesAirport = true;
  }

  setClosestAirport() {
    this.srcClosestDeltaAirportCodeSubscribe = this.srvClosestAirport
      .getClosestDeltaAirportCode()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.fromClosestAirportcode = data.airportcode;
            if (
              data.cityname === null ||
              data.cityname === '' ||
              data.statecode === null ||
              data.statecode === ''
            ) {
              this.fromClosestCity = '';
            } else {
              this.fromClosestCity = data.cityname + ', ' + data.statecode;
            }
            this.fromAirportcode = this.fromAirportcode
              ? this.fromAirportcode
              : this.fromClosestAirportcode;
            this.fromCountryCode = data.countrycode;
            this.fromCity = this.fromClosestCity;
            this.fromCountryCode = data.countrycode;
          }
        },
        (err) => {
          this.fromClosestAirportcode = '';
          this.fromClosestCity = '';
        }
      );
  }

  inputFocus(event) {
    this.inputBlur(event);
  }

  inputClick(event) {
    this.inputBlur(event);
  }

  inputBlur(event) {
    if (this.bookWidgetForm.get('dates.departureDate').value === undefined) {
      this.bookWidgetForm.get('dates.departureDate').setValue('');
    }

    if (this.bookWidgetForm.get('dates.returnDate').value === undefined) {
      this.bookWidgetForm.get('dates.returnDate').setValue('');
    }

    this.forHiddendepartureDate = this.formateDate(
      this.bookWidgetForm.get('dates.departureDate').value
    );

    this.forHiddenreturnDate = this.formateDate(
      this.bookWidgetForm.get('dates.returnDate').value
    );

    this.forHiddencabinFareClass = this.fareClass;

    if (this.awardTravel && this.isMilesMobileRedirect) {
      this.isFlexDate = false;
    } else if (event && event.target.checked) {
      this.isFlexDate = event.target.checked;
    } else {
      this.isFlexDate = this.bookWidgetForm.get(
        this.content.searchoptionLabel ? 'chkFlexDate' : 'dates.chkFlexDate'
      ).value;
    }

    if (this.odPairRestriction?.toLowerCase() === 'true') {
      this.setFlightHotelRestriction();
    }
    this.cdf.detectChanges();
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () => {
        if (this.fromShopHeader || this.isInAdvanceSearch) {
          this.getAccountData();
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {
      this.listenToEvents();
    }

    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (
            this.config.onBrowser &&
            this.contentService.contentHeaderFooter
          ) {
            this.onChangeServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe((data) => {
                  this.headerFooter = data;
                  if (data?.header?.primaryNavigations.get('book')) {
                    this.content =
                      data.header.primaryNavigations.get('book').details;
                    if (this.content?.passengertype.length !== 0) {
                      this.vaPaxDropDown = true;
                    }
                  }
                });
          }
        }
      });

    if (
      this.selectTripType === 'MULTICITY' &&
      changes &&
      changes.widgetTopPosition
    ) {
      this.enableCloseButton =
        changes.widgetTopPosition.currentValue === 'sticky' ? false : true;
    }
    if (
      (changes.isInAdvanceSearch && !this.canBookNonRefundable) ||
      (this.deviceTypes.isMobile &&
        !this.canBookNonRefundable &&
        this.corpPartner &&
        this.corpPartner.name !== 'default')
    ) {
      this.getAccountData();
    }
    if (this.isWidgetAlwaysExpanded) {
      this.isWidgetExpanded = true;
    }
    if (changes.fromAirport) {
      this.setFromAirport(this.fromAirport);
    }
    if (changes.toAirport) {
      this.setToAirport(this.toAirport);
    }
    if (changes.clickedOutside) {
      if (this.clickedOutside) {
        if (this.isAdvSearchExpanded) {
          this.isAdvSearchExpanded = !this.isAdvSearchExpanded;
          this.isAdvSearchAnimationDone = !this.isAdvSearchAnimationDone;
          this.cdf.detectChanges();
          this.advSearchExpanded.emit(this.isAdvSearchExpanded);
        }
        if (this.bookWidgetForm) {
          this.bookWidgetForm.get('meetingEventCode').clearValidators();
          this.bookWidgetForm.get('meetingEventCode').updateValueAndValidity();
        }
      }
    }
    if (changes.prefCity) {
      if (this.prefCity !== undefined && this.prefCity !== null) {
        this.prefCityVal = this.prefCity;
      }
    }
    if (changes.custId) {
      if (this.custId !== undefined && this.custId !== null) {
        if (this.custId !== this.customerId) {
          this.customerId = this.custId;
        }
      }
    }
    if (changes.isInAdvanceSearch && this.isInAdvanceSearch) {
      this.updDispValuesForAdvSearch();
    }
    if (changes.isEDPFlag) {
      if (this.isEDPFlag !== null && this.isEDPFlag !== undefined) {
        this.edpMeetingCodeEventMessage = this.setEdpMeetingEventCodeMessage();
      }
    }
    if (changes.recentSelected) {
      if (
        this.recentSelected !== null &&
        this.recentSelected !== undefined &&
        !this.trackerDataService?.getRecentSearchesLoaded()
      ) {
        if (this.bookWidgetForm) {
          this.setRecentSearchResults(this.recentSelected);
        }
      }
    }
    if (changes?.triggerDefaultLookupEvent?.currentValue === 'true') {
      this.triggerDefaultLookup();
    }
    if (changes.disabledByEdocData) {
      this.setEdocValues();
    }
    if (changes.savedSelected) {
      if (
        this.savedSelected !== null &&
        this.savedSelected !== undefined &&
        !this.trackerDataService?.getSavedSearchesLoaded()
      ) {
        this.setSaved(this.savedSelected);
      }
    }
    if (
      changes.advanchedSearchClicked &&
      !changes.advanchedSearchClicked.isFirstChange()
    ) {
      this.toggleAdvancedSearch(this.inMobile, null);
    }
    if (changes.invalidAirportCodes) {
      this.updateInvalidAirportCodes();
    }
    const clickedOutsideFlag = !changes?.clickedOutside;
    this.timeouts.push(
      setTimeout(() => {
        if (this.bookWidgetForm !== undefined) {
          if (clickedOutsideFlag) this.setDisplayValues();

          this.captureUIUpdates();
        }
      }, 0)
    );
  }

  updateInvalidAirportCodes() {
    if (
      !this.invalidAirportCodes ||
      !this.invalidAirportCodes.length ||
      !this.isViewInitialized
    ) {
      return;
    }
    if (!this.bookWidgetForm) {
      return;
    }
    const airports = this.bookWidgetForm.get('airports');
    if (!airports) {
      return;
    }
    const invalidAirportCodesCtr = airports.get('invalidAirportCodes');
    if (invalidAirportCodesCtr) {
      invalidAirportCodesCtr.setValue(this.invalidAirportCodes.join(','));
      this.bookWidgetForm.markAsDirty();
      if (this.errorHandler) {
        this.isSubmitted = true;
        this.errorHandler.resetTheForm();
        this.errorHandler.validateForm(true);
      }
    }
  }

  expandButtonClicked(event) {
    this.expandClicked.emit(event);
  }

  setFromAirport(event) {
    if (event) {
      this.fromAirportcode = event.airportCode;
      this.fromCountryCode = event?.countryCode ?? '';
      if (event.city !== '') {
        this.fromCity = event.city + ', ' + event.region;
      } else {
        this.fromCity = event.city;
      }
    }
  }

  setToAirport(event) {
    if (event) {
      this.toAirportcode = event.airportCode;
      this.toCountryCode = event?.countryCode ?? '';
      if (event.city !== '') {
        this.toCity = event.city + ', ' + event.region;
      } else {
        this.toCity = event.city;
      }
    }
  }

  setFromAndToAirport(fromAndToAirport) {
    this.setFromAirport(fromAndToAirport.fromAirport);
    this.setToAirport(fromAndToAirport.toAirport);
  }

  setAwardTravel(value: any) {
    let brandBEIndextemp = -1;
    if (this.basicEconomy !== '') {
      brandBEIndextemp = Object.keys(this.brands).findIndex(
        (key) => this.brands[key].brandId === 'BE'
      );
    }
    this.schedulePrice = value;
    this.isFlexAirPort = this.bookWidgetForm.controls['nearbyAirports'].value;
    if (value === 'price') {
      this.awardTravel = false;
      this.bookWidgetForm
        .get('meetingEventCode')
        .setValidators([
          Validators.maxLength(5),
          Validators.pattern('^[a-zA-Z0-9]*$')
        ]);
      if (brandBEIndextemp === -1 && this.basicEconomy !== '') {
        this.brands.splice(this.brandBEIndex, 0, this.brandBE);
      }
      if (this.isMilesMobileRedirect) {
        this.isFlexDate = false;
      } else {
        this.isFlexDate = this.bookWidgetForm.get(
          this.content && this.content.searchoptionLabel
            ? 'chkFlexDate'
            : 'dates.chkFlexDate'
        ).value;
      }
    } else {
      // ddcfb : miles AX changes
      if (!this.corpPartner.disableMiles || !this.restrictMiles) {
        this.awardTravel = true;
        if (this.isMilesMobileRedirect) {
          this.isFlexDate = false;
        } else if (this.isFlexAirPort) {
          this.isFlexDate = false;
        } else {
          this.isFlexDate = this.bookWidgetForm.get(
            this.content && this.content.searchoptionLabel
              ? 'chkFlexDate'
              : 'dates.chkFlexDate'
          ).value;
        }
        if (this.bookWidgetForm.get('chkFlexDate')) {
          if (
            this.isBusiness &&
            (!this.corpPartner.disableMiles || !this.restrictMiles)
          ) {
            this.bookWidgetForm.get('chkFlexDate').setValue(this.isFlexDate);
          } else {
            this.bookWidgetForm.get('chkFlexDate').setValue(this.isFlexDate);
          }
        }
        this.bookWidgetForm.get('meetingEventCode').clearValidators();
        if (brandBEIndextemp > -1 && this.basicEconomy !== '') {
          this.brands.splice(brandBEIndextemp, 1);
        }
      }
      if (
        this.awardTravel &&
        this.bookWidgetForm.get('refundableFlightsOnly')
      ) {
        this.bookWidgetForm.get('refundableFlightsOnly').setValue(false);
      }
    }
    this.bookWidgetForm.get('meetingEventCode').updateValueAndValidity();
    this.cdf.detectChanges();
    this.advSearchExpanded.emit(this.isAdvSearchExpanded);
    if (this.faresForDirective) {
      this.faresForDirective.reBind(this.brands, 'brandTitle', this.fareIndex);
      this.cdf.detectChanges();
    }
    if (
      !this.deviceTypes.isDesktop &&
      this.el.nativeElement.querySelector('#faresFor')
    ) {
      this.cdf.detectChanges();
      const fareEL = this.el.nativeElement.querySelector('#faresFor');
      this.fareClass =
        fareEL.options.length > 0
          ? fareEL.options[fareEL.selectedIndex].value
          : '';
    }
  }

  setFlexAirport() {
    if (this.selectTripType === 'MULTICITY') {
      this.isFlexAirPort = false;
      this.bookWidgetForm?.controls['nearbyAirports'].setValue(false);
    } else {
      this.isFlexAirPort =
        this.bookWidgetForm?.controls['nearbyAirports'].value;
    }
  }

  openCorporateRewards(evt) {
    if (this.corpPartner.showPopupForEcert && !this.content.eDocforDDCFB) {
      const bodyScroll = document.documentElement.scrollTop;
      let obj;
      const initialState = { isECertify: true, isCorporateRewards: true };
      obj = Object.assign({}, this.config, {
        class: 'dl-modal modal-popup-component',
        initialState
      });
      this.bsModalRef = this.modalService.show(FlyoutModalComponent, obj);
      // this.bsModalRef.content.isECertify = true;
      this.bsModalRef.content.action.subscribe((value) => {
        this.accountSummaryService.postAccountType('P').subscribe(
          (resp) => {},
          (error) => {
            console.log(error);
          }
        );
        // TODO need to navigate to that submit url
        const cookieObject = document.querySelector('span.pax-name')
          ? document.querySelector('span.pax-name')['innerText']
          : '';
        let stringifiedObject: any = {
          isBusiness: false,
          name: encodeURIComponent(cookieObject.toString()),
          businessAccountOptionsList: {
            isOaSmeAccount: false,
            partnerId: 'personal',
            accountIndex: 0
          }
        };
        stringifiedObject = JSON.stringify(stringifiedObject);
        this.switchingAccountService.setAdditionalBusinessUserInfo(
          null,
          null,
          null,
          null
        );
        this.cookieHelper.setCookieName('account', stringifiedObject, 0, true);
        window.location.href = window.location.origin + value;
      });
      this.bsModalRef.content.dialog.nativeElement.focus();
      this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (reason: string) => {
            evt.target.focus();
            this.modalServiceOnHiddenSubscribe.unsubscribe();
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
      this.srv.dragModalContainers(this.el, this.ren);
      document.documentElement.scrollTop = bodyScroll;
      this.srv.focusModalContainers(this.el, this.ren);
      return false;
    }
  }

  onEnterMeetingCode() {
    this.isMeetingCodeEnter = true;
  }

  onFocusMeetingCode() {
    this.meetingEvntCdFlag = true;
  }

  onFocusoutMeetingCode(meetingEventCode: HTMLInputElement, event: any) {
    setTimeout(() => {
      meetingEventCode.value = event.target.value.toUpperCase();
      this.meetingEvntCdFlag = false;
    }, 10);
  }

  onSubmit(from: any, e: any) {
    if (this.bookWidgetForm.valid) {
      /* if (this.businessAccount) {
        const bodyScroll = document.documentElement.scrollTop;
        if (this.bookWidgetForm.controls['meetingEventCode'].value) {
          let obj;
          const initialState = { isCorporateRewards: this.isMeetingCodeEnter };
          obj = Object.assign({}, this.config, {
            class: 'dl-modal modal-popup-component',
            initialState
          });
          this.bsModalRef = this.modalService.show(FlyoutModalComponent, obj);
          this.bsModalRef.content.action.subscribe(value => {
            this.submitAction(from, e);
          });
          this.bsModalRef.content.dialog.nativeElement.focus();
          this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(
              (reason: string) => {
                if (this.isMeetingCodeEnter) {
                  const _target = this.meetingEventCodeInput.nativeElement;
                  _target.focus();
                }
                this.isMeetingCodeEnter = false;
                this.modalServiceOnHiddenSubscribe.unsubscribe();
              },
              err => {
               this.loggingService.log('Caught Error: ' + err);
              }
            );
          this.srv.dragModalContainers(this.el, this.ren);
          document.documentElement.scrollTop = bodyScroll;
          this.srv.focusModalContainers(this.el, this.ren);
        } else {
          this.submitAction(from, e);
        }
      } else { */
      this.iropServiceSubscribe = this.iropService.getContent().subscribe(
        (irop: Irop) => {
          if (irop.iropType) window.document.location.href = iropErrorRedirect;
          else this.submitAction(from, e);
        },
        () => {
          this.submitAction(from, e);
        }
      );

      // }
    } else {
      this.isSubmitted = true;
      this.errorPresent.emit(true);
      this.errorHandler.validateForm(true);
    }
  }

  submitAction(from: any, e: any) {
    this.datalayer.setTrackingObjectProp1(
      'header:flight search:arrow',
      e.target
    );
    this.analytics.updateAnalytics(
      HEADER_MENU.BOOK.FLIGHT_SEARCH.NAME,
      HEADER_TOP_MENU.BOOK,
      HEADER_MENU_BOOK.FLIGHT_SEARCH
    );

    if (this.bookWidgetForm.get('selectTripType').value !== 'MULTICITY') {
      const recentdata =
        this.corpPartner && this.corpPartner.name
          ? this.bookWidgetForm.getRawValue()
          : this.bookWidgetForm.value;
      this.cookieHelper.setCookies('trip_type', '');

      if (this.bookWidgetForm.get('selectTripType').value === 'ONE_WAY') {
        if (recentdata.dates.returnDate) {
          recentdata.dates.returnDate = '';
        }
      }
      /** removing fromCountryCode and toCountryCode as said by shopping BFF team */
      const { fromCountryCode, toCountryCode, ...airportsObj } =
        recentdata.airports;
      recentdata.airports = airportsObj;
      recentdata.includeBasicFaresUnchecked =
        this._getIncludeBasicFaresUncheckedValue();
      delete recentdata.basicFaresField;
      this.srv.shoppingOptimization
        ? this.postRecentSearchesOptimized(recentdata, e)
        : this.postRecentSearches(recentdata, e);
    } else {
      // Generate a UID as a cache key.
      const mc_cache_key = this.cookieHelper.generateUID();

      // Set cookies for use later on other routes/apps on same domain
      this.cookieHelper.setCookies('mc_cache_key', mc_cache_key);

      this.cookieHelper.setCookies('trip_type', 'MULTICITY');

      // Create an mc-response object
      const multiCityResponse: MultiCityResponse = {
        cacheKey: mc_cache_key,
        value: {
          adtCount: this.bookWidgetForm.value.adtCount || '',
          adtGbeCount: this.bookWidgetForm.value.adtGbeCount || '',
          airports: [],
          awardTravel: this.bookWidgetForm.value.awardTravel || '',
          cnnCount: this.bookWidgetForm.value.cnnCount || '',
          dates: [],
          deltaOnly: this.bookWidgetForm.value.deltaOnly || '',
          departureTime: this.bookWidgetForm.value.departureTime || '',
          faresFor: this.bookWidgetForm.value.faresFor || '',
          flightHotelDeals: this.bookWidgetForm.value.flightHotelDeals || '',
          gbeCount: this.bookWidgetForm.value.gbeCount || '',
          infantCount: this.bookWidgetForm.value.infantCount || '',
          maxPaxCount: this.bookWidgetForm.value.maxPaxCount || '',
          meetingEventCode: this.bookWidgetForm.value.meetingEventCode || '',
          nearbyAirports: this.bookWidgetForm.value.nearbyAirports || '',
          passenger: this.bookWidgetForm.value.passenger || '',
          optionals: '',
          refundableFlightsOnly:
            this.bookWidgetForm.value.refundableFlightsOnly || '',
          returnTime: this.bookWidgetForm.value.returnTime || '',
          schedulePrice: this.bookWidgetForm.value.schedulePrice.value || '',
          selectTripType: this.bookWidgetForm.value.selectTripType || '',
          swapedFromCity: this.bookWidgetForm.value.swapedFromCity || '',
          swapedToCity: this.bookWidgetForm.value.swapedToCity || '',
          includeBasicFaresUnchecked: this._getIncludeBasicFaresUncheckedValue()
        }
      };

      // Assign flights values
      this.bookWidgetForm.value.flights.forEach((flight, i) => {
        // Assign flight data
        multiCityResponse.value.airports[i] = {
          connectionAirport: flight.connectionAirport
            ? flight.connectionAirport
            : '',
          connectionCity: '',
          fromAirportcode: flight.airports.fromAirportcode
            ? flight.airports.fromAirportcode
            : '',
          fromCity: flight.airports.fromCity ? flight.airports.fromCity : '',
          invalidAirportCodes: '',
          toAirportcode: flight.airports.toAirportcode
            ? flight.airports.toAirportcode
            : '',
          toCity: flight.airports.toCity ? flight.airports.toCity : '',
          fromCountryCode: flight.airports?.fromCountryCode ?? '',
          toCountryCode: flight.airports?.toCountryCode ?? ''
        };

        // Assign dates data
        multiCityResponse.value.dates[i] = {
          departureDate: flight.departureDate ? flight.departureDate : '',
          returnDate: ''
        };
      });

      // Send/post data to API
      this.srv.shoppingOptimization
        ? this.postMultiCitiesSearchesOptimized(multiCityResponse, e)
        : this.postMultiCitiesSearches(multiCityResponse, e);
    }
  }

  postMultiCitiesSearches(multiCityResponse: MultiCityResponse, e: any) {
    this.trackerPostRecentSearchesSubscribe = this.trackerDataService
      .postMultiCitiesSearches(multiCityResponse)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          if (this.actionChangeFlag === true) {
            this.searchFlightByQueryString(e);
          } else {
            e.target.submit();
          }
        },
        (errData) => {
          if (this.actionChangeFlag === true) {
            this.searchFlightByQueryString(e);
          } else {
            e.target.submit();
          }
        }
      );
  }

  postRecentSearches(recentdata: RecentData, e: any) {
    this.trackerPostRecentSearchesSubscribe = this.trackerDataService
      .postRecentSearches(recentdata)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          if (this.actionChangeFlag === true) {
            this.searchFlightByQueryString(e);
          } else {
            e.target.submit();
          }
        },
        (errData) => {
          if (this.actionChangeFlag === true) {
            this.searchFlightByQueryString(e);
          } else {
            e.target.submit();
          }
        }
      );
  }

  postMultiCitiesSearchesOptimized(
    multiCityResponse: MultiCityResponse,
    e: any
  ) {
    this.trackerDataService.multiCityResponse = multiCityResponse;
    if (this.actionChangeFlag === true) {
      this.searchFlightByQueryString(e);
    } else {
      e.target.submit();
    }
  }

  postRecentSearchesOptimized(recentdata: RecentData, e: any) {
    this.trackerDataService.recentData = recentdata;
    if (this.actionChangeFlag === true) {
      this.searchFlightByQueryString(e);
    } else {
      e.target.submit();
    }
  }

  submitMobileBook(event) {
    let flightSearchUrl = this.cache.get(
      makeStateKey('FLIGHT_SEARCH_URL'),
      undefined as any
    );
    const mobileRSB: boolean =
      this.config.get('APP_MOBILE_RSB') === 'true' ? true : false;
    if (
      (flightSearchUrl !== undefined &&
        flightSearchUrl !== null &&
        flightSearchUrl !== '' &&
        flightSearchUrl !== this.config.get('APP_MOBILE_WEB_URL')) ||
      mobileRSB
    ) {
      if (mobileRSB) {
        flightSearchUrl = this.bookSubmitUrl;
      }
      this.submitMobileResponsiveBook(flightSearchUrl, event);
    } else {
      this.submitMobileWeb();
    }
  }

  submitMobileResponsiveBook(flightSearchUrl: string, event) {
    /* Navigate to Responsive Shopping with URL from PE */
    let bookParams = new BookParameters();
    this.isShoppingAwsFlow = this.isSFAF;
    bookParams = this.getBookParams(bookParams);
    // build qerystring for search.
    let queryString = '';
    queryString = this.getQueryString(
      queryString,
      bookParams,
      false,
      true,
      true
    );
    bookParams = this.getAdditionalBookingParams(bookParams, true);
    // if (this.content.addDisableMetaSearch !== undefined && this.content.addDisableMetaSearch) {
    //   event.target.method = 'POST';
    //   event.target.action = flightSearchUrl;
    //   event.target.submit();
    // } else {
    //   const submitUrl =
    //     flightSearchUrl +
    //     (flightSearchUrl.indexOf('?') !== -1 ? '&' : '?') +
    //     queryString;

    //   window.document.location.href = submitUrl;
    // }
    this.flightSearchUtils.processSearch(
      bookParams,
      this.getCacheKeySuffix(),
      this.deepLinkVendorId,
      this.isShoppingAwsFlow,
      this.sfafFeatureFlags,
      !!this.custId,
      this.isEligibleBusinessUser()
    );
  }

  submitMobileWeb() {
    const submitUrl =
      this.content.mobileSubmitUrl +
      '?p=flightSearchResults&rhp=true&mkcpgn=' +
      this.mkcpgn +
      '&payload=';
    let payload;
    if (this.selectTripType === 'ONE_WAY') {
      payload = this.srvMDot.getBookPayloadForOneWay(
        this.bookWidgetForm.value,
        this.mkcpgn
      );
    } else if (this.selectTripType === 'ROUND_TRIP') {
      payload = this.srvMDot.getBookPayloadForRoundTrip(
        this.bookWidgetForm.value,
        this.mkcpgn
      );
    } else if (this.selectTripType === 'MULTICITY') {
      payload = this.srvMDot.getBookPayloadForMulticity(
        this.bookWidgetForm.value,
        this.mkcpgn
      );
    }
    if (payload) {
      this.srvMDot.getCompressedResponse(payload).subscribe(
        (res) => {
          window.document.location.href = submitUrl + res;
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    }
  }

  setDisclaimer() {
    if (
      document.getElementById('fph-disclaimer') !== null &&
      document.getElementById('fph-disclaimer') !== undefined
    ) {
      document.getElementById('fph-disclaimer').innerHTML = '';
    }
  }

  isChecked(event?: any, swapMobileMode?: boolean) {
    if (this.content && this.content.searchoptionLabel) {
      if ((event && event.target.checked) || swapMobileMode) {
        this.isFlightPlusHotelChecked = true;
      } else {
        this.isFlightPlusHotelChecked = false;
      }
    } else {
      const content = this.content.enableFlightPlusCar
        ? this.flightHotelContent.carDisclaimer
        : this.flightHotelContent.disclaimer;
      const bookingwidget = document.querySelector('.book-widget-container');
      const checkbox = document.querySelector('.checkbox-wrapper');
      if ((event && event.target.checked) || swapMobileMode) {
        document.getElementById('fph-disclaimer').innerHTML = content;
        this.isFlightPlusHotelChecked = true;
        if (window.innerWidth <= 991 && innerWidth >= 768) {
          checkbox.setAttribute('style', 'height: 4rem');
        } else if (window.innerWidth >= 300 && window.innerWidth <= 767) {
          checkbox.setAttribute('style', 'height: 6rem');
        } else if (window.innerWidth >= 992) {
          bookingwidget.setAttribute('style', 'min-height: 14.75rem');
        }
      } else {
        this.setDisclaimer();
        this.isFlightPlusHotelChecked = false;
        if (window.innerWidth <= 991) {
          checkbox.setAttribute('style', 'height: auto');
        } else if (window.innerWidth >= 992) {
          bookingwidget.setAttribute('style', 'min-height: 11.75rem');
        }
      }
    }
  }

  searchFlightByQueryString(event) {
    const flighHotelIntercept =
      this.content.flightPlusHotelIntercept !== undefined
        ? this.content.flightPlusHotelIntercept.toLowerCase() !== 'true'
          ? false
          : true
        : false;

    let flightHotelCheckBox = this.bookWidgetForm.get('flightHotelDeals').value;
    flightHotelCheckBox =
      flightHotelCheckBox === null ||
      flightHotelCheckBox === undefined ||
      flightHotelCheckBox === '' ||
      flightHotelCheckBox === false
        ? false
        : true;

    if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      flightHotelCheckBox &&
      !this.restrictFlightHotel &&
      !this.isDisableIntercept &&
      !flighHotelIntercept &&
      this.odPairRestriction
    ) {
      this.redirectToFlightHotel();
    } else if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      !flightHotelCheckBox &&
      flighHotelIntercept &&
      !this.restrictFlightHotel &&
      !this.isDisableIntercept &&
      this.odPairRestriction
    ) {
      this.openFlightHotelModal(event);
    } else if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      !this.restrictNonJvPartner &&
      this.odPairRestriction &&
      (this.isInterceptModalRequired === '' ||
        this.isInterceptModalRequired?.toLowerCase() === 'true')
    ) {
      this.openNonJVFlyingModal(event);
    } else if (
      this.odPairRestriction?.toLowerCase() === 'true' &&
      !this.restrictNonJvPartner &&
      this.odPairRestriction &&
      this.isInterceptModalRequired?.toLowerCase() === 'false'
    ) {
      this.processModal('dohop');
    } else {
      this.searchShopping(event);
    }
  }

  searchShopping(event) {
    this.clearCKOData();
    const callPE: boolean =
      this.config.get('APP_CALL_PE') !== undefined &&
      this.config.get('APP_CALL_PE') === 'true';
    const searchValueFromCookie = this.getSearchValueFromCookie();
    this.setContentBookSubmit();
    let callResponsive = false;
    if (this.config.get('APP_OLD_SHOP_BOOK') === 'false') {
      callResponsive = true;
    } else {
      callResponsive = false;
    }
    if (
      this.bookWidgetForm &&
      !this.isFlexDate &&
      !this.bookWidgetForm.value['nearbyAirports'] &&
      this.deviceTypes.isMobile &&
      this.content.mobileSubmitUrl &&
      this.config.get('APP_ENABLE_RESPONSIVE_BOOK') === 'false'
    ) {
      if (callPE) {
        if (
          searchValueFromCookie === '' ||
          searchValueFromCookie === undefined ||
          searchValueFromCookie === null
        ) {
          this.decideAndNavigateMobile(event);
        } else {
          this.actionUrl = searchValueFromCookie;
          this.navigateToShopping(true, event);
        }
      } else {
        // Delete SFAF Cookies
        this.deleteCookies();
        this.submitMobileBook(event);
      }
      return;
    } else {
      if (callPE) {
        if (
          searchValueFromCookie === '' ||
          searchValueFromCookie === undefined ||
          searchValueFromCookie === null
        ) {
          this.decideAndNavigate(event);
        } else {
          this.actionUrl = searchValueFromCookie;
          this.navigateToShopping(true, event);
        }
      } else {
        // Delete SFAF Cookies
        this.deleteCookies();
        this.navigateToShopping(callResponsive, event);
      }
    }
  }

  navigateToShopping(responsive, event) {
    let bookParams = new BookParameters();
    bookParams = this.getBookParams(bookParams);
    this.isShoppingAwsFlow = this.isSFAF;
    // build qerystring for search.
    let queryString = '';
    queryString = this.getQueryString(
      queryString,
      bookParams,
      false,
      true,
      responsive
    );
    bookParams = this.getAdditionalBookingParams(bookParams, responsive);
    if (this.config.get('APP_OLD_SHOP_BOOK') === 'false') {
      this.actionUrl = this.bookSubmitUrl;
    }
    this.actionUrl = this.actionUrl + '?' + queryString;
    if (this.config.get('APP_OLD_SHOP_BOOK') === 'true') {
      window.document.location.href =
        this.config.get('APP_OLD_URL') + this.actionUrl;
    } else if (this.content.addDisableMetaSearch) {
      const mkcpgn = this.config.get('APP_MKCPGN').toLowerCase();
      if (
        mkcpgn !== undefined &&
        mkcpgn !== null &&
        this._route.snapshot.queryParams[mkcpgn] !== undefined &&
        this._route.snapshot.queryParams[mkcpgn] !== null
      ) {
        this.bookSubmitUrl +=
          '?' + mkcpgn + '=' + this._route.snapshot.queryParams[mkcpgn];
      }
      event.target.method = 'POST';
      event.target.action = this.bookSubmitUrl;
      this.flightSearchUtils.processSearch(
        bookParams,
        this.getCacheKeySuffix(),
        this.deepLinkVendorId,
        this.isShoppingAwsFlow,
        this.sfafFeatureFlags,
        !!this.custId,
        this.isEligibleBusinessUser()
      );
      // event.target.submit();
    } else {
      // window.document.location.href = this.actionUrl;
      this.flightSearchUtils.processSearch(
        bookParams,
        this.getCacheKeySuffix(),
        this.deepLinkVendorId,
        this.isShoppingAwsFlow,
        this.sfafFeatureFlags,
        !!this.custId,
        this.isEligibleBusinessUser()
      );
    }
  }

  getBookParams(bookParams: BookParameters) {
    bookParams.action = 'findFlights';
    bookParams.tripType = this.selectTripType;
    bookParams.priceSchedule = 'PRICE';
    if (bookParams.tripType === 'MULTICITY') {
      bookParams.originCity = '';
      bookParams.destinationCity = '';
      bookParams.departureDate = '';
      bookParams.departureTime = ''; // 'AT';
      bookParams.returnDate = '';
      bookParams.returnTime = ''; // 'AT';
    } else {
      bookParams.originCity = this.fromAirportcode;
      bookParams.destinationCity = this.toAirportcode;
      bookParams.originCountryCode = this.fromCountryCode;
      bookParams.destinationCountryCode = this.toCountryCode;
      bookParams.departureDate = this.bookWidgetForm.get(
        'dates.departureDate'
      ).value;
      bookParams.departureTime =
        this.bookWidgetForm.controls['departureTime'].value; // 'AT';
      if (bookParams.tripType === 'ROUND_TRIP') {
        bookParams.returnDate =
          this.bookWidgetForm.get('dates.returnDate').value;
        bookParams.returnTime =
          this.bookWidgetForm.controls['returnTime'].value; // 'AT';
      } else {
        bookParams.returnDate = '';
        bookParams.returnTime = '';
      }
    }
    bookParams.paxCount = this.passenger;
    bookParams.searchByCabin = 'true';
    bookParams.cabinFareClass = this.fareClass;
    bookParams.deltaOnlySearch = 'false';
    bookParams.deltaOnly = this.bookWidgetForm.controls.deltaOnly.value;
    bookParams.go = 'Find Flights';
    bookParams.nearbyAirports = this.bookWidgetForm.controls['nearbyAirports']
      .value
      ? this.bookWidgetForm.controls['nearbyAirports'].value
      : false;
    bookParams.searchType = 'simple';
    if (this.awardTravel === true) {
      bookParams.meetingEventCode = '';
      bookParams.refundableFlightsOnly = 'false';
      if (
        this.odPairRestriction !== undefined &&
        this.odPairRestriction === 'true' &&
        this.selectTripType !== 'MULTICITY'
      ) {
        bookParams.datesFlexible = 'true';
      } else {
        bookParams.datesFlexible = 'false';
      }
      if (this.selectTripType === 'MULTICITY') {
        bookParams.nearbyAirports = 'false';
      }
    } else {
      bookParams.meetingEventCode =
        this.bookWidgetForm.controls['meetingEventCode'].value;
      bookParams.refundableFlightsOnly = this.bookWidgetForm.controls[
        'refundableFlightsOnly'
      ].value
        ? this.bookWidgetForm.controls['refundableFlightsOnly'].value
        : false;
      bookParams.datesFlexible = this.bookWidgetForm.get(
        this.content.searchoptionLabel ? 'chkFlexDate' : 'dates.chkFlexDate'
      ).value;
    }
    bookParams.upgradeRequest = 'false';
    bookParams.includeBasicFaresUnchecked =
      this._getIncludeBasicFaresUncheckedValue();
    return bookParams;
  }

  getQueryString(queryString, bookParams, redirectMPM, isDesktop, responsive) {
    const flightSearchUrl = this.cache.get(
      makeStateKey('FLIGHT_SEARCH_URL'),
      undefined as any
    );
    const isRSB =
      responsive || this.config.get('APP_SHOP_HEADER') === 'true'
        ? true
        : false;
    queryString += 'action=' + bookParams.action;
    queryString += '&';
    queryString += 'tripType=' + bookParams.tripType;
    queryString += '&';
    queryString += 'priceSchedule=' + bookParams.priceSchedule;
    queryString += '&';
    queryString += 'originCity=' + bookParams.originCity;
    queryString += '&';
    queryString += 'destinationCity=' + bookParams.destinationCity;
    queryString += '&';
    queryString += 'departureDate=' + bookParams.departureDate;
    queryString += '&';
    queryString += 'departureTime=' + bookParams.departureTime;
    queryString += '&';
    queryString += 'returnDate=' + bookParams.returnDate;
    queryString += '&';
    queryString += 'returnTime=' + bookParams.returnTime;
    if (!isRSB) {
      if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
        queryString += '&';
        queryString += 'paxCount=1';
      } else {
        queryString += '&';
        queryString += 'paxCount=' + this.passenger;
      }
    }
    queryString += '&';
    queryString += 'searchByCabin=' + bookParams.searchByCabin;
    queryString += '&';
    queryString += 'cabinFareClass=' + bookParams.cabinFareClass;
    queryString += '&';
    queryString += 'deltaOnlySearch=' + bookParams.deltaOnlySearch;
    queryString += '&';
    queryString += 'deltaOnly=' + bookParams.deltaOnly;
    queryString += '&';
    queryString += 'Go=Find Flights';
    queryString += '&';
    queryString += 'meetingEventCode=' + bookParams.meetingEventCode;
    queryString += '&';
    queryString += 'refundableFlightsOnly=' + bookParams.refundableFlightsOnly;
    queryString += '&';
    queryString += 'compareAirport=' + bookParams.nearbyAirports;
    queryString += '&';
    queryString += 'awardTravel=' + this.awardTravel;
    queryString += '&';
    queryString += 'datesFlexible=' + bookParams.datesFlexible;
    queryString += '&';
    queryString += 'flexAirport=' + bookParams.nearbyAirports;
    if (redirectMPM) {
      if (this.childPassenger) {
        queryString += '&';
        queryString += 'adtCount=' + this.adtCount;
        queryString += '&';
        queryString += 'gbeCount=' + this.gbeCount;
        queryString += '&';
        queryString += 'childCount=' + this.cnnCount;
        queryString += '&';
        queryString += 'infantCount=' + this.infCount;
      } else {
        if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
          queryString += '&';
          queryString += 'paxCount=1';
        } else {
          queryString += '&';
          queryString += 'paxCount=' + this.passenger;
        }
      }
    } else {
      if (
        !isRSB &&
        (this.childPassenger ||
          (isDesktop && this.config.get('APP_OLD_SHOP_BOOK') === 'true') ||
          (this.deviceTypes.isMobile &&
            this.schedulePrice === 'miles' &&
            this.config.get('APP_OLD_SHOP_BOOK') === 'true'))
      ) {
        queryString += '&';
        queryString += 'paxCounts[0]=' + (this.adtCount ?? this.passenger);
        queryString += '&';
        queryString += 'paxCounts[1]=' + (this.gbeCount ?? 0);
        queryString += '&';
        queryString += 'paxCounts[2]=' + (this.cnnCount ?? 0);
        queryString += '&';
        queryString += 'paxCounts[3]=' + (this.infCount ?? 0);
      } else if (isRSB) {
        queryString += '&';
        let passengerQueryString = 'passengerInfo=ADT:';
        if (this.childPassenger) {
          passengerQueryString =
            passengerQueryString + (this.adtCount ?? this.passenger);
        } else {
          passengerQueryString = passengerQueryString + this.passenger;
        }
        if (this.childPassenger) {
          if (this.gbeCount !== undefined && this.gbeCount !== 0) {
            passengerQueryString =
              passengerQueryString + '|' + 'GBE:' + this.gbeCount;
          }
          if (this.cnnCount !== undefined && this.cnnCount !== 0) {
            passengerQueryString =
              passengerQueryString + '|' + 'CNN:' + this.cnnCount;
          }
          if (this.infCount !== undefined && this.infCount !== 0) {
            passengerQueryString =
              passengerQueryString + '|' + 'INF:' + this.infCount;
          }
        }
        queryString = queryString + passengerQueryString;
      } else {
        if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
          queryString += '&';
          queryString += 'paxCounts[0]=1';
        } else {
          queryString += '&';
          queryString += 'paxCounts[0]=' + this.passenger;
        }
      }
    }
    const mkcpgn = this.config.get('APP_MKCPGN').toLowerCase();
    if (
      mkcpgn !== undefined &&
      mkcpgn !== null &&
      this._route.snapshot.queryParams[mkcpgn] !== undefined &&
      this._route.snapshot.queryParams[mkcpgn] !== null
    ) {
      queryString += '&';
      queryString += mkcpgn + '=' + this._route.snapshot.queryParams[mkcpgn];
    }
    if (bookParams.tripType === 'MULTICITY') {
      bookParams.flights = [];
      const bookFlightParams = new BookFlightParameter();
      let queryStringMultiCity = '';
      if (this.bookWidgetForm.controls.flights) {
        const flights = (<UntypedFormArray>(
          this.bookWidgetForm.controls['flights']
        )).controls;

        for (let i = 0; i < flights.length; i++) {
          const flight = <UntypedFormGroup>flights[i];
          queryStringMultiCity += '&';
          queryStringMultiCity +=
            'originCity[' +
            (i + 1) +
            ']=' +
            flight.get('airports.fromAirportcode').value;
          queryStringMultiCity += '&';
          queryStringMultiCity +=
            'destinationCity[' +
            (i + 1) +
            ']=' +
            flight.get('airports.toAirportcode').value;
          queryStringMultiCity += '&';
          queryStringMultiCity +=
            'departureDate[' +
            (i + 1) +
            ']=' +
            flight.controls['departureDate'].value;
          queryStringMultiCity += '&';
          queryStringMultiCity +=
            'departureTime[' +
            (i + 1) +
            ']=' +
            this.bookWidgetForm.controls['departureTime'].value;
          queryStringMultiCity += '&';
          queryStringMultiCity +=
            'connectionCity[' +
            (i + 1) +
            ']=' +
            flight.controls['connectionAirport'].value;
        }
      }
      queryString = queryString + queryStringMultiCity;
    }
    if (this.shopExperience !== undefined && this.shopExperience !== null) {
      queryString += '&';
      queryString +=
        this.config.get('APP_SHOP_EXPERIENCE') + '=' + this.shopExperience;
    }
    return queryString;
  }

  getAdditionalBookingParams(
    bookParams: BookParameters,
    responsive: boolean
  ): BookParameters {
    const isRSB =
      responsive || this.config.get('APP_SHOP_HEADER') === 'true'
        ? true
        : false;
    bookParams.awardTravel = this.awardTravel ? 'true' : 'false';
    bookParams.shopType = this.awardTravel ? 'AWARD' : 'REVENUE';
    bookParams.bookingPostVerify = 'RTR_YES';
    bookParams.bundled = 'off';
    bookParams.schedulePrice =
      this.bookWidgetForm.controls['schedulePrice'].value;
    bookParams.datesFlexible = this.isFlexDate;
    if (bookParams.schedulePrice === 'miles') {
      bookParams.shopWithMiles = 'on';
    }
    if (this.shopExperience !== undefined && this.shopExperience !== null) {
      bookParams.se = this.shopExperience;
    }
    bookParams.go = 'Find Flights';
    if (!isRSB) {
      if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
        bookParams.paxCount = '1';
      } else {
        bookParams.paxCount = this.passenger;
      }
    }
    if (
      !isRSB &&
      (this.childPassenger ||
        this.config.get('APP_OLD_SHOP_BOOK') === 'true' ||
        (this.deviceTypes.isMobile &&
          this.schedulePrice === 'miles' &&
          this.config.get('APP_OLD_SHOP_BOOK') === 'true'))
    ) {
      bookParams.paxcounts = [];
      bookParams.paxcounts[0] = this.adtCount ?? this.passenger;
      bookParams.paxcounts[1] = this.gbeCount ?? 0;
      bookParams.paxcounts[2] = this.cnnCount ?? 0;
      bookParams.paxcounts[3] = this.infCount ?? 0;
    } else if (isRSB) {
      if (this.childPassenger) {
        bookParams.adtCount = this.adtCount ?? this.passenger;
      } else {
        bookParams.adtCount = this.passenger;
      }
      if (this.childPassenger) {
        if (this.gbeCount !== undefined && this.gbeCount !== 0) {
          bookParams.gbeCount = this.gbeCount;
        }
        if (this.cnnCount !== undefined && this.cnnCount !== 0) {
          bookParams.childCount = this.cnnCount;
        }
        if (this.infCount !== undefined && this.infCount !== 0) {
          bookParams.infantCount = this.infCount;
        }
      }
    } else {
      if (!bookParams.paxcounts) {
        bookParams.paxcounts = [];
      }
      if (this.corpPartner.restrictPaxToOne || this.restrictNewPaxToOne) {
        bookParams.paxcounts[0] = '1';
      } else {
        bookParams.paxcounts[0] = this.passenger;
      }
    }
    const mkcpgn = this.config.get('APP_MKCPGN').toLowerCase();
    if (
      mkcpgn !== undefined &&
      mkcpgn !== null &&
      this._route.snapshot.queryParams[mkcpgn] !== undefined &&
      this._route.snapshot.queryParams[mkcpgn] !== null
    ) {
      bookParams.mkcpgn =
        mkcpgn + '=' + this._route.snapshot.queryParams[mkcpgn];
    }
    if (bookParams.tripType === 'MULTICITY') {
      bookParams.flights = [];
      if (this.bookWidgetForm.controls.flights) {
        const flights = (<UntypedFormArray>(
          this.bookWidgetForm.controls['flights']
        )).controls;
        bookParams.originCities = [];
        bookParams.destinationCities = [];
        bookParams.originCountryCodes = [];
        bookParams.destinationCountryCodes = [];
        bookParams.departureDates = [];
        bookParams.departureTimes = [];
        bookParams.connectionCity = [];

        for (let i = 0; i < flights.length; i++) {
          const flight = <UntypedFormGroup>flights[i];
          bookParams.originCities[i] = flight.get(
            'airports.fromAirportcode'
          ).value;
          bookParams.destinationCities[i] = flight.get(
            'airports.toAirportcode'
          ).value;
          bookParams.departureDates[i] = flight.controls['departureDate'].value;
          bookParams.departureTimes[i] =
            this.bookWidgetForm.controls['departureTime'].value;
          bookParams.connectionCity[i] =
            flight.controls['connectionAirport'].value;
          bookParams.originCountryCodes[i] =
            flight.controls.airports.get('fromCountryCode')?.value;
          bookParams.destinationCountryCodes[i] =
            flight.controls.airports.get('toCountryCode')?.value;
        }
      }
    }
    return bookParams;
  }

  getDuration() {
    let departDate = this.bookWidgetForm.get('dates.departureDate').value;
    departDate = new Date(departDate);
    const departMM = departDate.getMonth() + 1;
    const departDD = departDate.getDate();
    const departYY = departDate.getFullYear();
    const returnDate = new Date(
      this.bookWidgetForm.get('dates.returnDate').value
    );
    const datediff = Math.abs(returnDate.getTime() - departDate.getTime());
    const duration = '' + datediff / (24 * 60 * 60 * 1000);
    return duration;
  }

  redirectToFlightHotel() {
    const domain = this.content.enableFlightPlusCar
      ? this.flightHotelContent.travelplusCarDomain
      : this.flightHotelContent.travelplusDomain;
    let queryParam = '' + this.flightHotelDest + '?';
    const duration = this.getDuration();
    let departDate = this.bookWidgetForm.get('dates.departureDate').value;
    departDate = new Date(departDate);
    const departMM = departDate.getMonth() + 1;
    const departDD = departDate.getDate();
    const departYY = departDate.getFullYear();
    const returnDate = new Date(
      this.bookWidgetForm.get('dates.returnDate').value
    );
    queryParam =
      queryParam +
      'departureDate=' +
      (departDD.toString().length === 1
        ? '0' + departDD.toString()
        : departDD) +
      '-' +
      (departMM.toString().length === 1
        ? '0' + departMM.toString()
        : departMM) +
      '-' +
      departYY +
      '&';
    queryParam = queryParam + 'duration=' + duration + '&';
    queryParam = queryParam + 'gateway=' + this.fromAirportcode + '&';
    let pax = 'room=';
    if (this.vaPaxDropDown && this.isMultiPax) {
      pax = pax + 'a' + this.adtCount + ',i' + this.infCount;
      if (this.cnnCount > 0) {
        for (
          let tempCnnCount = 0;
          tempCnnCount < this.cnnCount;
          tempCnnCount++
        ) {
          pax = pax + ',c8';
        }
      }
      if (this.gbeCount > 0) {
        for (let tempCount = 0; tempCount < this.gbeCount; tempCount++) {
          pax = pax + ',c14';
        }
      }
    } else {
      pax = pax + 'a' + this.passenger;
    }
    queryParam = queryParam + pax;
    window.document.location.href = domain + queryParam;
  }

  redirectToDoHop() {
    const domain = this.nonJVFlyingContent.travelplusDomain;
    let queryParam = 'flights/';
    let departDate = this.bookWidgetForm.get('dates.departureDate').value;
    departDate = new Date(departDate);
    const departMM = departDate.getMonth() + 1;
    const departDD = departDate.getDate();
    const departYY = departDate.getFullYear();
    const returnDate = new Date(
      this.bookWidgetForm.get('dates.returnDate').value
    );
    let returnDateStr = '';
    if (this.selectTripType !== 'ONE_WAY') {
      const returnMM = returnDate.getMonth() + 1;
      const returnDD = returnDate.getDate();
      const returnYY = returnDate.getFullYear();
      returnDateStr =
        returnYY +
        '-' +
        (returnMM.toString().length === 1
          ? '0' + returnMM.toString()
          : returnMM) +
        '-' +
        (returnDD.toString().length === 1
          ? '0' + returnDD.toString()
          : returnDD) +
        '/';
    }
    queryParam =
      queryParam + this.fromAirportcode + '/' + this.toAirportcode + '/';
    queryParam =
      queryParam +
      departYY +
      '-' +
      (departMM.toString().length === 1
        ? '0' + departMM.toString()
        : departMM) +
      '-' +
      (departDD.toString().length === 1
        ? '0' + departDD.toString()
        : departDD) +
      '/';
    if (this.selectTripType !== 'ONE_WAY') {
      queryParam = queryParam + returnDateStr;
    }
    let pax;
    if (this.vaPaxDropDown && this.isMultiPax) {
      const youngAdtCnt = this.gbeCount + this.cnnCount;
      pax = this.adtCount + '-adults';
      if (this.gbeCount > 0 || this.cnnCount > 0 || this.infCount > 0) {
        pax = pax + '/children';
        for (let k = 0; k < this.infCount; k++) {
          pax = pax + '-1';
        }
        for (let j = 0; j < this.cnnCount; j++) {
          pax = pax + '-8';
        }
        for (let i = 0; i < this.gbeCount; i++) {
          pax = pax + '-14';
        }
      }
    } else {
      pax = 'adults-' + this.passenger;
    }
    queryParam = queryParam + pax;
    queryParam = queryParam + '?lang=en&res=US';
    window.document.location.href = domain + queryParam;
  }

  redirectMilesPlusMoney() {
    this.bookWidgetForm.controls['chkFlexDate'].setValue(false);
    this.prefillSetAwardTravel('price');
    if (
      this.custId !== undefined &&
      this.custId !== null &&
      this.custId !== ''
    ) {
    } else {
      this.actionUrl = this.config.get('APP_MPM_URL');
      let bookParams = new BookParameters();
      bookParams = this.getBookParams(bookParams);
      // build qerystring for search.
      let queryString = '';
      queryString = this.getQueryString(
        queryString,
        bookParams,
        true,
        true,
        false
      );
      this.actionUrl = this.config.get('APP_OLD_URL') + this.loginUrl;
      this.actionUrl =
        this.actionUrl +
        this.config.get('APP_REFRESH_URL') +
        '=' +
        window.location.href +
        this.config.get('APP_MPM_URL');
      // window.document.location.href = this.actionUrl + '&' + queryString;
      this.mpmForm.nativeElement.action =
        window.location.origin + this.loginUrl;
      this.mpmForm.nativeElement.refreshURL.value =
        window.location.href +
        this.config.get('APP_MPM_URL') +
        '&' +
        queryString;
      this.mpmForm.nativeElement.submit();
    }
  }

  getLabel(count, type) {
    let vaPassenger: any;
    vaPassenger = this.content.passengertype;
    for (let index = 0; index < vaPassenger.length; index++) {
      if (vaPassenger[index].passengertypeId === type) {
        if (count === 1) {
          return vaPassenger[index].passengerSingular;
        } else if (count > 1) {
          return vaPassenger[index].passengerPlural;
        }
      }
    }
  }

  getPassengerForModal() {
    let passenger = '';
    if (this.vaPaxDropDown && this.isMultiPax) {
      if (this.adtCount > 0) {
        passenger =
          passenger + this.adtCount + ' ' + this.getLabel(this.adtCount, 'ADT');
      }
      if (this.gbeCount !== 0) {
        passenger =
          passenger +
          ', ' +
          this.gbeCount +
          ' ' +
          this.getLabel(this.gbeCount, 'GBE');
      }

      if (this.cnnCount !== 0) {
        passenger =
          passenger +
          ', ' +
          this.cnnCount +
          ' ' +
          this.getLabel(this.cnnCount, 'CNN');
      }

      if (this.infCount !== 0) {
        passenger =
          passenger +
          ', ' +
          this.infCount +
          ' ' +
          this.getLabel(this.infCount, 'INF');
      }
    } else {
      passenger =
        passenger +
        this.passenger +
        this.getLabel(parseInt(this.passenger), 'ADT');
    }
    return passenger;
  }

  openFlightHotelModal(event) {
    const bodyScroll = document.documentElement.scrollTop;
    const passenger = this.getPassengerForModal();
    const odpair = this.fromAirportcode + ' to ' + this.toAirportcode;
    let departDate = this.bookWidgetForm.get('dates.departureDate').value;
    departDate = new Date(departDate);
    const departMM = this.getMonthName(departDate.getMonth());
    const deplartDD = departDate.getDate();

    let returnDate = this.bookWidgetForm.get('dates.returnDate').value;
    returnDate = new Date(returnDate);
    const returnMM = this.getMonthName(returnDate.getMonth());
    const reutrnDD = returnDate.getDate();

    let dates = '';
    if (this.selectTripType === 'ROUND_TRIP') {
      dates =
        'Depart ' +
        departMM +
        ' ' +
        deplartDD +
        ' - Return ' +
        returnMM +
        ' ' +
        reutrnDD;
    } else {
      dates = 'Depart ' + departMM + ' ' + deplartDD;
    }
    const initialState = {
      destination: odpair,
      passengers: passenger,
      travelDates: dates,
      destinationCity: this.toCity,
      modalType: 'FPH'
    };
    const obj = Object.assign({}, this.config, {
      class: 'flightplushotel-modal-dialog no-transform',
      initialState
    });
    this.bsModalRef = this.modalService.show(FlightPlusHotelComponent, obj);
    this.bsModalRef.content.action.subscribe((value) => {
      this.processModal(value);
    });
    /* Jira -814 Added for accessibility */
    this.bsModalRef.content.dialog.nativeElement.focus();
    this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (reason: string) => {
          event.target.focus();
          const _target =
            this.bookSubmitEl
              .nativeElement; /*jira-814, AX focus to submit button*/
          _target.focus();
          this.modalServiceOnHiddenSubscribe.unsubscribe();
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.srv.dragModalContainers(this.el, this.ren);
    document.documentElement.scrollTop = bodyScroll;
    this.srv.focusModalContainers(this.el, this.ren);
  }

  openNonJVFlyingModal(event) {
    const bodyScroll = document.documentElement.scrollTop;
    const passenger = this.getPassengerForModal();
    const odpair = this.fromAirportcode + ' to ' + this.toAirportcode;
    let departDate = this.bookWidgetForm.get('dates.departureDate').value;
    departDate = new Date(departDate);
    const departMM = this.getMonthName(departDate.getMonth());
    const deplartDD = departDate.getDate();
    let returnDate = this.bookWidgetForm.get('dates.returnDate').value;
    returnDate = new Date(returnDate);
    const returnMM = this.getMonthName(returnDate.getMonth());
    const reutrnDD = returnDate.getDate();
    let dates = '';
    if (this.selectTripType === 'ROUND_TRIP') {
      dates = departMM + ' ' + deplartDD + ' - ' + returnMM + ' ' + reutrnDD;
    } else {
      dates = 'Depart ' + departMM + ' ' + deplartDD;
    }
    const destination =
      this.toCity === '' &&
      this.tempDestinationCity !== null &&
      this.tempDestinationCity !== undefined
        ? this.tempDestinationCity
        : this.toCity;
    const initialState = {
      destination: odpair,
      passengers: passenger,
      travelDates: dates,
      destinationCity: destination,
      modalType: 'JV'
    };
    const obj = Object.assign({}, this.config, {
      class: 'flightplushotel-modal-dialog non-jv-modal no-transform',
      initialState
    });
    this.bsModalRef = this.modalService.show(FlightPlusHotelComponent, obj);
    this.bsModalRef.content.action.subscribe((value) => {
      this.processModal(value);
    });
    /* Jira -814 Added for accessibility */
    this.bsModalRef.content.dialog.nativeElement.focus();
    this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (reason: string) => {
          event.target.focus();
          const _target =
            this.bookSubmitEl
              .nativeElement; /*jira-814, AX focus to submit button*/
          _target.focus();
          this.modalServiceOnHiddenSubscribe.unsubscribe();
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.srv.dragModalContainers(this.el, this.ren);
    document.documentElement.scrollTop = bodyScroll;
    this.srv.focusModalContainers(this.el, this.ren);
  }

  processModal(value) {
    if (value === 'search') {
      this.searchShopping(event);
    } else if (value === 'dohop') {
      this.redirectToDoHop();
    } else if (value === 'fph') {
      this.redirectToFlightHotel();
    } else if (value === 'cancel') {
    }
  }

  getPrefCity(flag) {
    this.prefCityVal = flag;
    if (this.prefCityVal !== '' && this.prefCityVal !== undefined) {
      this.fromAirportcode = this.fromAirportcode || this.prefCityVal;
      this.fromCity = '';
      this.preferredCityChecked = true;
    }
  }

  getMonthName(v) {
    const n = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    return n[v];
  }

  airportFieldToFocus() {
    if (!this.fromAirportcode || this.fromAirportcode === '') {
      return 'fromAirportName';
    }
    if (!this.toAirportcode || this.toAirportcode === '') {
      return 'toAirportName';
    }
    return 'toAirportName';
  }

  getSelectedDate(dd, mm, yyyy) {
    if (dd.toString().length < 2) {
      dd = '0' + dd;
    }
    if (mm.toString().length < 2) {
      mm = '0' + mm;
    }
    return mm + '/' + dd + '/' + yyyy;
  }

  setFlightPlusHotel() {
    this.isDisableIntercept =
      this.config.get('APP_SHOP_HEADER') === 'true' ? true : false;

    if (this.isDisableIntercept) {
      this.flightPlusHotel = false;
    } else {
      if (
        this.content.flightPlusHotelLabel !== undefined &&
        this.content.flightPlusHotelLabel !== '' &&
        this.content?.flightPlusHotelIntercept?.toLowerCase() !== 'true'
      ) {
        this.flightPlusHotel = true;
      } else {
        this.flightPlusHotel = false;
      }
    }
  }

  setMPMTravel() {
    const showMobileMPM =
      this.config.get('APP_MOBILE_MPM') === 'true' ? true : false;

    if (
      showMobileMPM &&
      this.deviceTypes.isMobile &&
      this.content.milesPlusMoneyLabel !== undefined &&
      this.content.milesPlusMoneyLabel !== null &&
      this.content.milesPlusMoneyLabel !== ''
    ) {
      this.mpmTravel = true;
    } else if (
      !this.deviceTypes.isMobile &&
      this.content.milesPlusMoneyLabel !== undefined &&
      this.content.milesPlusMoneyLabel !== null &&
      this.content.milesPlusMoneyLabel !== ''
    ) {
      this.mpmTravel = true;
    } else {
      this.mpmTravel = false;
    }
  }

  setMilesMobileRedirect() {
    const overRideMilesRedirect =
      this.config.get('APP_MILES_MOBILE_REDIRECT') === 'true';
    if (
      !overRideMilesRedirect &&
      this.deviceTypes.isMobile &&
      this.content.milesMobileRedirect
    ) {
      this.isMilesMobileRedirect = true;
    } else {
      this.isMilesMobileRedirect = false;
    }
  }

  setMaxPassenger() {
    if (
      this.content.maxNumberOfPax !== null &&
      this.content.maxNumberOfPax !== undefined
    ) {
      this.bookWidgetForm.controls['maxPaxCount'].setValue(
        this.content.maxNumberOfPax
      );
    } else {
      this.bookWidgetForm.controls['maxPaxCount'].setValue('9');
    }
    this.bookWidgetForm.get('passenger').clearValidators();
    this.bookWidgetForm
      .get('passenger')
      .setValidators([
        adtPaxCount('adtCount'),
        totalPaxCount,
        infantPaxCount('adtGbeCount', 'infantCount')
      ]);
    this.bookWidgetForm.controls['passenger'].setValue(this.passenger);
  }

  searchWidgetPrefilling() {
    const fromAirport = this.queryParam.originCity;
    this.prefillClosestAirport =
      fromAirport !== '' && fromAirport !== 'undefined' ? true : false;
    this.fromAirportcode = this.prefillClosestAirport ? fromAirport : '';
    this.fromCity = '';
    const toAirport: any = this.queryParam.destinationCity;
    this.toAirportcode = toAirport;
    this.toCity = '';
    this.selectTripType = this.queryParam.tripType
      ? this.queryParam.tripType
      : this.selectTripType;
    // this.bookWidgetForm.controls['refundableFlightsOnly'].setValue((this.queryParam.refundableFlightsOnly === 'true') ? true : false);
    this.awardTravel = this.queryParam.awardTravel === 'true';
    if (!this.isInAdvanceSearch) {
      this.bookWidgetForm.get('schedulePrice').setValue('milesplusmoney');
    }
    if (this.awardTravel === true) {
      this.prefillSetAwardTravel('miles');
    } else {
      this.prefillSetAwardTravel('price');
    }

    this.bookWidgetForm.controls['nearbyAirports'].setValue(
      this.queryParam.flexAirport === 'true' ? true : false
    );
    const meetingEventCode = this.queryParam.meetingEventCode
      ? this.queryParam.meetingEventCode.trim()
      : '';
    this.bookWidgetForm.get('meetingEventCode').setValue(meetingEventCode);
    this.triptypeIndex = this.getTripTypeIndex(this.queryParam.tripType);
    let paxCount = this.queryParam.paxCount;
    // default pax count for deep links to advance search page
    if ((!paxCount || !paxCount.length) && this.isInAdvanceSearch) {
      paxCount = '1';
    }
    this.paxIndex =
      paxCount !== undefined && paxCount !== '' ? parseInt(paxCount) : 0;
    this.passenger = paxCount !== undefined && paxCount !== '' ? paxCount : '';
    this.fareClass = this.queryParam.cabinFareClass;
    const selectedIndex = Object.keys(this.brands).findIndex(
      (key) => this.brands[key].brandId === this.fareClass
    );
    if (selectedIndex >= 0) {
      this.fareIndex = selectedIndex;
    }
    this.bookWidgetForm
      .get('dates.departureDate')
      .setValue(this.queryParam.departureDate);
    this.forHiddendepartureDate = this.formateDate(
      this.bookWidgetForm.get('dates.departureDate').value
    );
    this.forHiddencabinFareClass = this.fareClass;
    if (this.selectTripType === 'ROUND_TRIP') {
      this.bookWidgetForm
        .get('dates.returnDate')
        .setValue(this.queryParam.returnDate);
      this.forHiddenreturnDate = this.formateDate(
        this.bookWidgetForm.get('dates.returnDate').value
      );
    }
    if (this.awardTravel && this.isMilesMobileRedirect) {
      this.isFlexDate = false;
    } else if (this.awardTravel && !this.isMilesMobileRedirect) {
      this.isFlexDate = true;
    } else {
      this.isFlexDate = this.bookWidgetForm.get(
        this.content.searchoptionLabel ? 'chkFlexDate' : 'dates.chkFlexDate'
      ).value;
    }
    this.removeAllFormControl();
    this.addFormControlFor(this.selectTripType);
  }

  prefillSetTripType(tripTypeData) {
    this.selectTripType = tripTypeData;
    if (this.bookWidgetForm) {
      // this.errorHandler.resetTheForm();
    }
    // this.removeAllFormControl();
    // this.addFormControlFor(tripTypeData);
    this.isSubmitted = false;
    this.setFlexAirport();
    const mobileWidgetScrollableContainer = document.getElementsByClassName(
      'mobile-widget-scrollable-container'
    )[0];
    if (
      mobileWidgetScrollableContainer !== undefined &&
      mobileWidgetScrollableContainer !== null
    ) {
      if (tripTypeData === 'MULTICITY' && !this.isAdvSearchExpanded) {
        mobileWidgetScrollableContainer.classList.add(
          'mobile-widget-multicity-container'
        );
      } else {
        mobileWidgetScrollableContainer.classList.remove(
          'mobile-widget-multicity-container'
        );
      }
    }
  }

  prefillSetAwardTravel(value) {
    if (value === 'price') {
      this.awardTravel = false;
      this.bookWidgetForm
        .get('meetingEventCode')
        .setValidators([
          Validators.maxLength(5),
          Validators.pattern('^[a-zA-Z0-9]*$')
        ]);
      if (this.isMilesMobileRedirect) {
        this.isFlexDate = false;
      } else {
        this.isFlexDate = this.bookWidgetForm.get(
          this.content.searchoptionLabel ? 'chkFlexDate' : 'dates.chkFlexDate'
        ).value;
      }
    } else {
      this.awardTravel = true;
      this.bookWidgetForm.get('meetingEventCode').clearValidators();
      if (this.isMilesMobileRedirect) {
        this.isFlexDate = false;
      } else {
        this.isFlexDate = true;
        this.bookWidgetForm
          .get(
            this.content.searchoptionLabel ? 'chkFlexDate' : 'dates.chkFlexDate'
          )
          .setValue(this.isFlexDate);
        this.bookWidgetForm.controls['schedulePrice'].setValue(value);
      }
    }
    this.bookWidgetForm.get('meetingEventCode').updateValueAndValidity();
    this.cdf.detectChanges();
    if (this.faresForDirective) {
      if (
        this.custId !== undefined &&
        this.custId !== null &&
        this.custId !== ''
      ) {
        this.faresForDirective.reBind(this.brands, 'brandTitle');
        this.cdf.detectChanges();
      }
    }
    if (!this.deviceTypes.isDesktop) {
      this.cdf.detectChanges();
    }
  }

  formateDate(dateString: any) {
    if (dateString === undefined) {
      dateString = '';
    }
    dateString = dateString.split('/');
    dateString = dateString[2] + '-' + dateString[0] + '-' + dateString[1];
    return dateString;
  }

  getDateString(date: Date) {
    let dateString;
    dateString =
      this.addLeadingZero(date.getMonth() + 1) +
      '/' +
      this.addLeadingZero(date.getDate()) +
      '/' +
      date.getFullYear();
    return dateString;
  }

  addLeadingZero(monthOrDay) {
    let result = monthOrDay;
    if (monthOrDay < 10) {
      result = '0' + monthOrDay;
    }
    return result;
  }

  /*
   * Rendering of fields such as airport names have become complicated and buggy
   * Bugs have been reported to display odd values like [object] or null
   * This function adds a few checks to these strings before trying to render them
   * so that the end user experience is still salvaged inspite of these bugs
   */
  getValidStringValue(description, defaultDescription): string {
    if (description) {
      let countryDescription = description.split(',')[0];
      if (this.isValidString(countryDescription)) {
        return description;
      }
    }
    if (this.isValidString(defaultDescription)) {
      return defaultDescription;
    }
    return '';
  }

  onAwardTravelChanged(type) {
    this.shopWithMilesClicked = type === 'miles';
    if (type && type !== 'milesplusmoney') {
      this.setAwardTravel(type);
    } else if (type === 'milesplusmoney') {
      this.schedulePrice = type;
      this.redirectMilesPlusMoney();
    }
  }

  onFlexiDatesChanged(isChecked) {
    this.isFlexDate = isChecked;
    if (this.isAdvSearchExpanded) {
      this.cdf.detectChanges();
      this.advSearchExpanded.emit(this.isAdvSearchExpanded);
    }
  }

  setEdpMeetingEventCodeMessage(): string {
    if (!this.meetingInlineTextCodeData) {
      return '';
    }

    if (
      this.corpPartner.displayInlineText ===
        this.meetingInlineTextCodeData['rewards'] ||
      this.newProfileSelectorDisplayInlineText ===
        this.meetingInlineTextCodeData['rewards']
    ) {
      return this.edpMeetingCodeDisclaimerList
        .edpMeetingCodeDisclaimerForProgram;
    }
    if (
      this.corpPartner.displayInlineText ===
        this.meetingInlineTextCodeData['noprogram'] ||
      this.newProfileSelectorDisplayInlineText ===
        this.meetingInlineTextCodeData['noprogram']
    ) {
      return this.edpMeetingCodeDisclaimerList
        .edpMeetingCodeDisclaimerForNoProgram;
    }
    if (
      this.corpPartner.displayInlineText ===
        this.meetingInlineTextCodeData['fare'] ||
      this.newProfileSelectorDisplayInlineText ===
        this.meetingInlineTextCodeData['fare']
    ) {
      return this.edpMeetingCodeDisclaimerList.edpMeetingCodeDisclaimerForFare;
    }
    if (
      this.corpPartner.displayInlineText ===
        this.meetingInlineTextCodeData['personal'] ||
      this.newProfileSelectorDisplayInlineText ===
        this.meetingInlineTextCodeData['personal']
    ) {
      return this.edpMeetingCodeDisclaimerList.edpMeetingCodeDisclaimer;
    }
    return '';
  }

  setAwardTravelMoney(value) {
    if (value === 'price') {
      this.bookWidgetForm.controls['chkFlexDate'].setValue(false);
      this.setAwardTravel(value);
    }
  }

  setAwardTravelMiles(value) {
    if (value === 'miles') {
      this.bookWidgetForm.controls['chkFlexDate'].setValue(true);
      this.setAwardTravel(value);
    }
  }

  setCorpPartner() {
    try {
      const isDeepLinkProcess =
        this.srv.getDeepLinkVendor() === '' ? false : true;
      let deepLinkXssid;
      let deepLinkCacheKey;
      let deepLinkVendor;
      if (isDeepLinkProcess) {
        deepLinkXssid = this.getQueryParams('deepLinkXssid');
        deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
        deepLinkVendor = this.getQueryParams('vendorID');
      }
      const deepLinkCacheKeyCookieValue =
        this.cookieHelper.getCookieValue('deepLinkCacheKey');
      const deepLinkVendorCookieValue = this.cookieHelper.getCookieValue(
        'deepLinkVendor' + deepLinkCacheKey
      );
      if (
        isDeepLinkProcess &&
        deepLinkVendor &&
        deepLinkVendor === this.srv.getDeepLinkVendor()
      ) {
        this.srv.setDeepLinkVendorCookie(deepLinkVendor, deepLinkCacheKey);
        this.corpPartner = getCorporatePartner(deepLinkVendor);
      } else if (
        isDeepLinkProcess &&
        deepLinkCacheKey &&
        deepLinkCacheKey === deepLinkCacheKeyCookieValue &&
        deepLinkVendorCookieValue &&
        deepLinkVendorCookieValue === this.srv.getDeepLinkVendor()
      ) {
        this.corpPartner = getCorporatePartner(deepLinkVendorCookieValue);
      } else {
      }
    } catch (error) {}
  }

  setDeepLinkVendor() {
    if (this.srv.getDeepLinkVendor() && this.srv.getDeepLinkVendor() !== '') {
      this.deepLinkVendorId = this.getQueryParams('vendorId');
      if (!this.deepLinkVendorId) {
        const deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
        const deepLinkCacheKeyCookieValue =
          this.cookieHelper.getCookieValue('deepLinkCacheKey');
        const deepLinkVendorCookieValue = this.cookieHelper.getCookieValue(
          'deepLinkVendor' + deepLinkCacheKey
        );
        if (
          deepLinkCacheKey &&
          deepLinkCacheKey === deepLinkCacheKeyCookieValue &&
          deepLinkVendorCookieValue &&
          deepLinkVendorCookieValue === this.srv.getDeepLinkVendor()
        ) {
          this.deepLinkVendorId = deepLinkVendorCookieValue;
        }
      }
    }
  }

  getSearchValueFromCookie() {
    const flightSearchCookie =
      this.cookieHelper.getCookieValue(this.SFAFCookiesName) !== null
        ? this.cookieHelper.getCookieValue(this.SFAFCookiesName)
        : '';
    if (this.config.get('APP_OLD_SHOP_BOOK') === 'true') {
      if (
        flightSearchCookie !== undefined &&
        flightSearchCookie !== null &&
        flightSearchCookie !== ''
      ) {
        return decodeURIComponent(flightSearchCookie);
      } else {
        return '';
      }
    }
  }

  decideAndNavigateMobile(event) {
    const searchPERequest = new SearchPERequest();
    const peRequest = this.preparePEPayload();
    searchPERequest.populateUserData(
      peRequest.deviceType,
      peRequest.language,
      peRequest.countryCode,
      peRequest.mkcpgnValue,
      peRequest.tripType,
      peRequest.origin,
      peRequest.destination,
      peRequest.shopType,
      peRequest.isloggedIn,
      peRequest.noofpassengers,
      peRequest.meetingEventCode,
      peRequest.flexAirport,
      peRequest.flexDate,
      peRequest.refundableFlightsOnly
    );
    searchPERequest.populateRequestParam('flowrouter:experiences-home', '');

    const appURL = this.cookieHelper.getCookieValue(this.SFAFCookiesName);
    if (
      appURL &&
      (appURL.includes('flightsearch') || appURL.includes('flight-search'))
    ) {
      this.actionUrl = appURL;
      if (
        this.isBusinessUser() &&
        !!this.custId &&
        !this.sfafFeatureFlags.enableSFAFDDCFB
      ) {
        this.isShoppingAwsFlow = false;
        this.navigateToShopping(true, event);
      } else {
        this.isShoppingAwsFlow = appURL.includes('flightsearch');
        this.navigateToShopping(true, event);
      }
    } else if (
      this.isBusinessUser() &&
      !!this.custId &&
      !this.sfafFeatureFlags.enableSFAFDDCFB
    ) {
      this.actionUrl = appURL;
      this.isShoppingAwsFlow = false;
      this.navigateToShopping(true, event);
    } else {
      this.srv
        .getPEDataForSearch(searchPERequest)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            try {
              const endpoint = Object.keys(res).length
                ? res['flowrouter:experiences-home']['parsys']['router'][
                    'endpoint'
                  ]
                : null;
              const expiry = Object.keys(res).length
                ? res['flowrouter:experiences-home']['parsys']['router'][
                    'experience'
                  ]
                : 1;
              if (endpoint) {
                this.actionUrl = endpoint;
                this.isShoppingAwsFlow = endpoint.includes('flightsearch');
                this.cookieHelper.setCookieValue(
                  this.SFAFCookiesName,
                  endpoint,
                  expiry
                );
                this.navigateToShopping(true, event);
              } else {
                this.isShoppingAwsFlow =
                  this.actionUrl.includes('flightsearch');
                this.submitMobileWeb();
              }
            } catch (err) {
              /**
               * isShoppingAwsFlow should be false if pe calls fails or there is error processing the pe resposne
               */
              this.isShoppingAwsFlow = false;
              this.submitMobileWeb();
              console.log(
                'Mobile : Caught Error while getting PE response for Search: ' +
                  err,
                'error'
              );
            }
          },
          (err) => {
            /**
             * isShoppingAwsFlow should be false if pe calls fails or there is error processing the pe resposne
             */
            this.isShoppingAwsFlow = false;
            this.submitMobileWeb();
            console.log(
              'Mobile : Caught Error while getting PE Response for search from second : ' +
                err,
              'error'
            );
          }
        );
    }
  }

  decideAndNavigate(event) {
    const searchPERequest = new SearchPERequest();
    const peRequest = this.preparePEPayload();
    searchPERequest.populateUserData(
      peRequest.deviceType,
      peRequest.language,
      peRequest.countryCode,
      peRequest.mkcpgnValue,
      peRequest.tripType,
      peRequest.origin,
      peRequest.destination,
      peRequest.shopType,
      peRequest.isloggedIn,
      peRequest.noofpassengers,
      peRequest.meetingEventCode,
      peRequest.flexAirport,
      peRequest.flexDate,
      peRequest.refundableFlightsOnly
    );
    searchPERequest.populateRequestParam('flowrouter:experiences-home', '');

    const appURL = this.cookieHelper.getCookieValue(this.SFAFCookiesName);
    if (
      appURL &&
      (appURL.includes('flightsearch') || appURL.includes('flight-search'))
    ) {
      this.actionUrl = appURL;
      if (
        this.isBusinessUser() &&
        !!this.custId &&
        !this.sfafFeatureFlags.enableSFAFDDCFB
      ) {
        this.isShoppingAwsFlow = false;
        this.navigateToShopping(true, event);
      } else {
        this.isShoppingAwsFlow = appURL.includes('flightsearch');
        this.navigateToShopping(true, event);
      }
    } else if (
      this.isBusinessUser() &&
      !!this.custId &&
      !this.sfafFeatureFlags.enableSFAFDDCFB
    ) {
      this.actionUrl = appURL;
      this.isShoppingAwsFlow = false;
      this.navigateToShopping(true, event);
    } else {
      this.srv
        .getPEDataForSearch(searchPERequest)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            try {
              const endpoint = Object.keys(res).length
                ? res['flowrouter:experiences-home']['parsys']['router'][
                    'endpoint'
                  ]
                : null;
              const expiry = Object.keys(res).length
                ? res['flowrouter:experiences-home']['parsys']['router'][
                    'experience'
                  ]
                : 1;
              if (endpoint) {
                this.actionUrl = endpoint;
                this.isShoppingAwsFlow = endpoint.includes('flightsearch');
                this.cookieHelper.setCookieValue(
                  this.SFAFCookiesName,
                  endpoint,
                  expiry
                );
                this.navigateToShopping(true, event);
              } else {
                this.isShoppingAwsFlow =
                  this.actionUrl.includes('flightsearch');
                this.navigateToShopping(false, event);
              }
            } catch (err) {
              /**
               * isShoppingAwsFlow should be false if pe calls fails or there is error processing the pe resposne
               */
              this.isShoppingAwsFlow = false;
              this.navigateToShopping(false, event);
              console.log(
                'Caught Error while getting PE response for Search: ' + err,
                'error'
              );
            }
          },
          (err) => {
            /**
             * isShoppingAwsFlow should be false if pe calls fails or there is error processing the pe resposne
             */
            this.isShoppingAwsFlow = false;
            this.navigateToShopping(false, event);
            console.log(
              'Caught Error while getting PE Response for search from second : ' +
                err,
              'error'
            );
          }
        );
    }
  }

  preparePEPayload() {
    const deviceType = this.deviceTypes.isDesktop ? 'desktop' : 'mobile';
    const countryCode = this.cookieHelper.getCountryCode();
    const language = this.cookieHelper.getlanguageCode();
    const mkcpgn = this.config.get('APP_MKCPGN').toLowerCase();
    const tripType = this.selectTripType;
    const origin = this.fromAirportcode;
    const destination = this.toAirportcode;
    const shopType = this.awardTravel ? 'AWARD' : 'REVENUE';
    const mkcpgnValue =
      mkcpgn !== undefined &&
      mkcpgn !== null &&
      this._route.snapshot.queryParams[mkcpgn] !== undefined &&
      this._route.snapshot.queryParams[mkcpgn] !== null
        ? this._route.snapshot.queryParams[mkcpgn]
        : '';
    const isloggedIn = this.isloggedIn;
    const noofpassengers = this.passenger;
    const meetingEventCode =
      this.bookWidgetForm.controls['meetingEventCode'].value;
    const flexAirport = this.bookWidgetForm.controls['nearbyAirports'].value;
    const flexDate = this.isFlexDate;
    const refundableFlightsOnly =
      this.bookWidgetForm.controls['refundableFlightsOnly'].value;
    return {
      deviceType,
      countryCode,
      language,
      tripType,
      origin,
      destination,
      shopType,
      mkcpgnValue,
      isloggedIn,
      noofpassengers,
      meetingEventCode,
      flexAirport,
      flexDate,
      refundableFlightsOnly
    };
  }

  private _getSFAFEnabled(SFAF: TriggerLoginModal[]): boolean {
    const appStatus: TriggerLoginModal[] = SFAF.filter(
      (item: TriggerLoginModal) =>
        item.appName.toLowerCase() === this.CURRENT_APP_NAME.toLowerCase()
    );
    return appStatus.length > 0 && appStatus[0].sfaf === 'true' ? true : false;
  }

  getShoppingOptimization(shopOptimization: TriggerLoginModal[]): boolean {
    let shoppingOptimization = false;
    if (shopOptimization) {
      const appStatus: TriggerLoginModal[] = shopOptimization.filter(
        (item: TriggerLoginModal) =>
          item.appName.toLowerCase() === this.CURRENT_APP_NAME.toLowerCase()
      );
      return appStatus.length > 0 &&
        appStatus[0].shoppingOptimization === 'true'
        ? true
        : false;
    }
    return shoppingOptimization;
  }

  configureSFAFFeatureFlags(applications: TriggerLoginModal[]) {
    this.sfafFeatureFlags = {
      enableSFAFFlexAirports: false,
      enableSFAFFlexDatesAndCalendar: false,
      enableSFAFFlexDatesAndCalendarWithLogin: false,
      enableSFAFDDCFB: false
    };

    try {
      const application: TriggerLoginModal = applications?.find(
        (item: TriggerLoginModal) =>
          item.appName.toLowerCase() === this.CURRENT_APP_NAME.toLowerCase()
      );

      if (application) {
        this.sfafFeatureFlags = {
          enableSFAFFlexAirports: application.enableSFAFFlexAirports === 'true',
          enableSFAFFlexDatesAndCalendar:
            application.enableSFAFFlexDatesAndCalendar === 'true',
          enableSFAFFlexDatesAndCalendarWithLogin:
            application.enableSFAFFlexDatesAndCalendarWithLogin === 'true',
          enableSFAFDDCFB: application.enableSFAFDDCFB === 'true'
        };
      }
    } catch {
      this.loggingService.log('Error Reading SFAF Feature Flags');
    }
  }

  deleteCookies() {
    if (this.cookieHelper.getCookieValue(this.SFAFCookiesName)) {
      this.cookieHelper.deleteCookie(this.SFAFCookiesName);
    }
  }

  isBusinessUser() {
    let businessUser = false;
    const isloggedIn = !!this.custId;
    if (isloggedIn) {
      const accountCookieString = this.cookieHelper.getCookieValue('account');
      if (accountCookieString) {
        const accountCookieValue = JSON.parse(accountCookieString);
        if (accountCookieValue && accountCookieValue.isBusiness) {
          businessUser = true;
        }
      }
    }

    return businessUser;
  }

  isEligibleBusinessUser() {
    let eligibleBusinessUser = false;
    if (this.isBusinessUser() && !this.sfafFeatureFlags.enableSFAFDDCFB) {
      eligibleBusinessUser = false;
    } else if (this.sfafFeatureFlags.enableSFAFDDCFB && this.isBusinessUser()) {
      eligibleBusinessUser = true;
    }
    return eligibleBusinessUser;
  }

  clearCKOData() {
    try {
      localStorage.removeItem('marketTypeAWS');
      localStorage.removeItem('originDestination');
      this.clearCookie('cko_aws');
      if (this.clearCKOCookie) {
        this.clearCookie('cko_aws');
        this.clearCookie('cko_aws_awd');
        this.clearCookie('cko_aws_rev');
      }
      for (let index = 0; index < localStorage.length; index++) {
        const key = localStorage.key(index);
        if (key.includes('cko_')) {
          localStorage.removeItem(key);
        }
      }
    } catch (error) {
      this.clearCookie('cko_aws');
      this.clearCookie('cko_aws_awd');
      this.clearCookie('cko_aws_rev');
    }
  }

  clearCookie(cookieName: string) {
    const date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    // Set it
    document.cookie =
      cookieName + '=; expires=' + date.toUTCString() + ';path=/';
  }

  private getTripTypeIndex(tripType) {
    switch (tripType) {
      case 'ONE_WAY':
        return 1;
      case 'MULTICITY':
        return 2;
      case 'ROUND_TRIP':
      default:
        return 0;
    }
  }

  private getRecentSearchCallParams() {
    const tripType = this.cookieHelper.getTripType();
    if (tripType === 'multicity') {
      const mc_cache_key = this.cookieHelper.getMcCacheKey();
      if (mc_cache_key?.length) {
        return {
          serviceCall:
            this.trackerDataService.getUncachedMultiCityRecentSearches(
              mc_cache_key
            ),
          multicity: true
        };
      }
    }

    return {
      serviceCall: this.trackerDataService.getRecentSearches(),
      multicity: false
    };
  }

  private getFareForValue(selection): string {
    if (selection?.schedulePrice?.value?.length) {
      if (selection.schedulePrice.value === 'money') {
        return 'price';
      } else {
        return selection.schedulePrice.value.toLowerCase();
      }
    }
    return 'price';
  }

  private rebindDropdowns() {
    //TODO : refactor this. do not rebinddropdowns  AWS path
    const isAWS =
      window.location.href.includes('flightsearch') ||
      window.location.href.includes('completepurchase');
    if (this.isViewInitialized && !isAWS) {
      this.viewInitializedCheck = true;
      if (this.tripTypeDropdown) {
        this.tripTypeDropdown.reBind(
          this.uiTripTypes,
          'tripTypeTitle',
          this.triptypeIndex
        );
      }
      if (this.pasDropdown) {
        this.pasDropdown.reBind(
          this.content.passengers,
          'passengerTitle',
          this.paxIndex
        );
      }
      if (this.bestFareDropdown) {
        this.bestFareDropdown.reBind(this.brands, 'brandTitle', this.fareIndex);
      }
    }
  }

  private setBookSubmitUrl() {
    if (this.config.get('APP_SHOP_HEADER') === 'true') {
      this.toggleAdvancedSearch(false, null);
      this.setContentBookSubmit();
    }
  }

  private setContentBookSubmit() {
    if (this.config.get('APP_SHOP_HEADER') === 'true') {
      if (this.content !== undefined && this.content.addDisableMetaSearch) {
        this.setBookSubmitUrlCacheKey(); // Added to have cacheKey added if any - EDOC scenario
      } else {
        this.bookSubmitUrl = this.config.get('APP_SHOP_HEADER_URL');
      }
    }
  }

  private getCacheKeySuffix() {
    const cacheKeySuffixQueryParam = this.config.get('APP_CACHEKEY');
    if (this.cacheKeySuffix !== '' && this.cacheKeySuffix !== undefined) {
      this.cacheKeySuffixVal = this.cacheKeySuffix;
    } else if (
      cacheKeySuffixQueryParam !== undefined &&
      cacheKeySuffixQueryParam !== null &&
      this._route.snapshot.queryParams[cacheKeySuffixQueryParam] !==
        undefined &&
      this._route.snapshot.queryParams[cacheKeySuffixQueryParam] !== null
    ) {
      this.cacheKeySuffixVal =
        this._route.snapshot.queryParams[cacheKeySuffixQueryParam];
    } else if (isPlatformBrowser(this.platformId)) {
      const queryString = window.location.href.split('?')[1];
      const params = queryString ? queryString.split('&') : [];
      if (params.length > 0) {
        for (let i = 0; i < params.length; i++) {
          if (params[i].match('cacheKeySuffix')) {
            this.cacheKeySuffixVal = params[i].split('=')[1];
          }
        }
      }
    }
    if (
      this.generateCacheKey &&
      !this.isEdocApplied &&
      this.cacheKeySuffixVal &&
      !localStorage.getItem(`postData${this.cacheKeySuffixVal}`)
    ) {
      this.cacheKeySuffixVal = '';
    }
    return this.cacheKeySuffixVal;
  }

  private setBookSubmitUrlCacheKey() {
    const cacheKeySuffixQueryParam = this.config.get('APP_CACHEKEY'); // Config to be added at shoplite-2
    if (this.cacheKeySuffix !== '' && this.cacheKeySuffix !== undefined) {
      // Added RSB13149 Edoc Fix cacheKeySuffix
      this.cacheKeySuffixVal = this.cacheKeySuffix;
      this.bookSubmitUrl =
        this.config.get('APP_SEARCH_SHOP_HEADER_URL') +
        '?cacheKeySuffix=' +
        this.cacheKeySuffixVal;
    } else if (
      cacheKeySuffixQueryParam !== undefined &&
      cacheKeySuffixQueryParam !== null &&
      this._route.snapshot.queryParams[cacheKeySuffixQueryParam] !==
        undefined &&
      this._route.snapshot.queryParams[cacheKeySuffixQueryParam] !== null
    ) {
      this.cacheKeySuffixVal =
        this._route.snapshot.queryParams[cacheKeySuffixQueryParam];
      this.bookSubmitUrl =
        this.config.get('APP_SEARCH_SHOP_HEADER_URL') +
        '?cacheKeySuffix=' +
        this.cacheKeySuffixVal;
    } else {
      this.bookSubmitUrl = this.config.get('APP_SEARCH_SHOP_HEADER_URL');
    }
  }

  private isValidString(value): boolean {
    if (value) {
      if (value.length && typeof value === 'string') {
        const lowerCase = value.toLowerCase();
        const wrongStringValues = ['null', 'undefined'];
        if (wrongStringValues.indexOf(lowerCase) < 0) {
          return true;
        }
      }
    }
    return false;
  }

  private showMobileMultiPax() {
    const showMobileMultiPaxProperty =
      this.config.get('APP_MOBILE_MULTI_PAX') === 'true' ? true : false;
    if (!this.deviceTypes.isMobile && this.vaPaxDropDown) {
      this.isMultiPax = true;
    } else if (
      this.deviceTypes.isMobile &&
      this.vaPaxDropDown &&
      showMobileMultiPaxProperty
    ) {
      this.isMultiPax = true;
    } else {
      this.isMultiPax = false;
    }
  }

  private triggerSavedSearch(customerId): void {
    if (
      customerId &&
      this.headerFooter &&
      this.headerFooter.header &&
      this.headerFooter.header.primaryNavigations
    ) {
      this.savedSearchService
        .getSavedSearchFeatureFlag()
        .pipe(
          takeUntil(this.unsubscribe),
          filter((endPoint) => !!endPoint),
          concatMap((endPoint: string) =>
            this._processSearchResults(endPoint, customerId)
          ),
          catchError((error) => {
            this.setSavedSearchesAirport(customerId);
            return this._handleError(
              error as Error,
              'error checking saved search feature flag'
            );
          })
        )
        .subscribe();
    }
  }

  loadSavedSearchOnClick(): void {
    if (this.customerId) {
      this.triggerSavedSearch(this.customerId);
    }
  }

  private _processSearchResults(
    endPoint: string,
    customerId: string
  ): Observable<SavedSearchesStatus | never> {
    const flags: SavedSearchFlags = {
      gql: endPoint,
      config:
        this.config.get('APP_SAVED_SEARCH_API_GRAPHQL').toLowerCase() === 'true'
    };
    if (isGQLEnabled(flags)) {
      this.issetSavedSearchesAirport = true;
      return this._getSavedSearchesStatus(customerId, endPoint).pipe(
        tap((response: SavedSearchesStatus) => {
          this._handleSearchStatus(response);
        })
      );
    } else {
      this.setSavedSearchesAirport(customerId);
      return EMPTY;
    }
  }

  private _handleSearchStatus(response: SavedSearchesStatus) {
    this.savedSearches = response.searches;
    this.savedSearchesAvailable = response.available;
  }

  private _getSavedSearchesStatus(
    customerId: string,
    endPoint: string
  ): Observable<SavedSearchesStatus> {
    return this.savedSearchService
      .getSavedSearchWithResponse(
        customerId,
        this.headerFooter.header.primaryNavigations.get('book').details.brands,
        endPoint
      )
      .pipe(
        takeUntil(this.unsubscribe),
        map((response: SavedSearchGQLResponse) => {
          return this._adaptSavedSearchesStatus(response);
        }),
        catchError((error) =>
          this._handleError(error as Error, 'error calling savedSearchFromGQL')
        )
      );
  }

  private _adaptSavedSearchesStatus(
    response: SavedSearchGQLResponse
  ): SavedSearchesStatus {
    this._handleSavedSearchResponse();
    if (response.trips.length && this.bookWidgetForm !== undefined) {
      this.cdf.detectChanges();
    }
    return {
      searches: response.savedSearches,
      available: response.trips.length ? true : false
    };
  }

  private _handleSavedSearchResponse() {
    if (this.bookWidgetForm !== undefined) {
      this.setDisplayValues();
    }
  }

  private _handleError(error: Error, message: string) {
    logError(error, 'HEADER', 'SHARED', 'SAVED_SEARCH_TRIP', message);
    return throwError(error);
  }

  private _getGenerateCacheLey(SFAF: TriggerLoginModal[]): boolean {
    const appStatus: TriggerLoginModal[] = SFAF.filter(
      (item: TriggerLoginModal) =>
        item.appName.toLowerCase() === this.CURRENT_APP_NAME.toLowerCase()
    );
    return appStatus.length > 0 && appStatus[0].generateCacheKey === 'true'
      ? true
      : false;
  }

  private _enableBasicFareFeature() {
    return (
      this.content?.includeBasicFares &&
      !this.disabledByEdocData?.hideBasicFares
    );
  }

  private _getIncludeBasicFaresUncheckedValue() {
    let includeBasicFaresUnchecked = false;
    if (
      this._enableBasicFareFeature() &&
      this.bookWidgetForm?.controls?.['basicFaresField']?.value === false
    ) {
      includeBasicFaresUnchecked = true;
    }

    return includeBasicFaresUnchecked;
  }
}
